import React, { useState, useCallback, useEffect, useRef } from 'react'
import { Platform, ScrollView, TextInput, Animated, Modal, ImageBackground, Button, StyleSheet, Text, TouchableOpacity, View, useWindowDimensions, Dimensions, Pressable } from 'react-native'

import { useNavigation, useIsFocused, useScrollToTop, useFocusEffect } from '@react-navigation/native'
import { Ionicons, MaterialCommunityIcons } from '@expo/vector-icons'

import { useQuery } from '@apollo/client'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import { FIND_MANY_OBJECTS } from '../gqls'

import { imageUrl } from '../utils/const'
import { favoritesVar } from '../utils/cache'
import { useUser } from '../hooks/user'

import Loading from '../components/Loading'
import Error from '../components/Error'
import Footer from '../components/Footer'
import Window from '../components/Window'
import Map from '../components/Map'
import CreatableSelect from 'react-select/creatable';
import { Calendar } from 'react-native-calendars';
import Select from 'react-select'

const ObjectsScreen = ({ route }) => {
    const { width } = useWindowDimensions()
    const { height } = Dimensions.get('window');
    const navigation = useNavigation()
    const isFocused = useIsFocused()
    const { user, refetch } = useUser()

    const [take, setTake] = useState(10); // Количество объектов на страницу
    const [skip, setSkip] = useState(0);

    const [from, setFrom] = useState(undefined)
    const [to, setTo] = useState(undefined)
    const [date, setDate] = useState(undefined)
    const [week, setWeek] = useState(undefined)
    const [people, setPeople] = useState(undefined)
    const [selectedPlace, setSelectedPlace] = useState([])
    const [company, setCompany] = useState(undefined)
    const [comfort, setComfort] = useState(undefined)
    const [sort, setSort] = useState(undefined)
    const [bed, setBed] = useState(undefined)
    const [heat, setHeat] = useState(undefined)
    const [place, setPlace] = useState('')

    const [sortBy, setSortBy] = useState('');

    const [selectedTags, setSelectedTags] = useState([]);

    const [mode, setMode] = useState('list')

    const isMobile = width <= 1024;

    const [modalFilter, setModalFilter] = useState(false);
    const opacityAnim = useRef(new Animated.Value(0)).current;

    const [showFilterCalendar, setShowFilterCalendar] = useState(false);

    const [searchQuery, setSearchQuery] = useState('');
    const [debouncedQuery, setDebouncedQuery] = useState(searchQuery);

    const [convenience, setConvenience] = useState([])
    const [minPrice, setMinPrice] = useState('');
    const [maxPrice, setMaxPrice] = useState('');
    const [bedCount, setBedCount] = useState('');
    const [peopleCount, setPeopleCount] = useState('');
    const [filteredObjects, setFilteredObjects] = useState([]);

    const [isExpanded, setIsExpanded] = useState(false);
    const [dateFilter, setDateFilter] = useState('');
    const [peopleFilter, setPeopleFilter] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [formattedDate, setFormattedDate] = useState('');
    const [selectedObjectMap, setSelectedObjectMap] = useState(null);
    const [modalObjectMap, setModalObjectMap] = useState(false);
    const slideAnim = useRef(new Animated.Value(height)).current;
    const today = dayjs().format('YYYY-MM-DD');
    const [isSearchListVisible, setIsSearchListVisible] = useState(false);
    const ref = useRef(null);
    useScrollToTop(ref);

    useFocusEffect(
        React.useCallback(() => {
            // Обновляем фильтры при каждом фокусе на экране
            if (route.params?.dateFilter || route.params?.peopleFilter) {
                setDateFilter(route.params.dateFilter || '');
                setPeopleFilter(route.params.peopleFilter || '');
                refreshData(route.params.dateFilter, route.params.peopleFilter); // Функция для обновления данных
            }
        }, [route.params])
    );

    const refreshData = (date, people) => {
        console.log('Обновляем данные:', { date, people });
    };

    useEffect(() => {
        if (dateFilter) {
            setSelectedDate(dateFilter);
        }
    }, [dateFilter, selectedDate]);

    useEffect(() => {
        if (peopleFilter) {
            setPeopleCount(peopleFilter);
        }
    }, [peopleFilter, peopleCount]);

    useEffect(() => {
        if (selectedDate) {
            const formatDate = (date) => {
                const [year, month, day] = date.split('-');
                return `${day}.${month}.${year}`;
            };

            setFormattedDate(formatDate(selectedDate)); // обновляем состояние отформатированной даты
        }
    }, [selectedDate]);

    useEffect(() => {
        if (modalFilter) {
            Animated.timing(opacityAnim, {
                toValue: 1, // Полностью видимый элемент
                duration: 300, // Длительность анимации в миллисекундах
                useNativeDriver: true, // Использование нативных драйверов для улучшенной производительности
            }).start();
        } else {
            Animated.timing(opacityAnim, {
                toValue: 0, // Полностью скрытый элемент
                duration: 300,
                useNativeDriver: true,
            }).start();
        }
    }, [modalFilter, opacityAnim]);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedQuery(searchQuery);
        }, 300);

        return () => {
            clearTimeout(handler);
        };
    }, [searchQuery]);

    useEffect(() => {
        if (isFocused) {
            refetch()
        }
    }, [isFocused])

    useEffect(() => {
        if (window.location.hash == '#map')
            setMode('map')
    },)

    function isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    function openObject(id, date) {
        if (Platform.OS === 'web') {
            if (isMobile)
                navigation.navigate('Object', { id: id, date })
            else
                window.open("/objects/" + id + (date != "" ? '?date=' + date : ''))
        } else
            navigation.navigate('Object', { id: id, date })
    }

    const getSort = () => {
        if (sort === 'guestMax') {
            return [
                {
                    people: {
                        sort: 'asc'
                    }
                },
            ]
        }
        if (sort === 'guestMin') {
            return [
                {
                    people: {
                        sort: 'desc'
                    }
                },
            ]
        }
        return [
            {
                premium: 'desc',
            },
            {
                createdAt: 'asc'
            }
        ]
    }

    const { data: findManyObjectData, loading: findManyObjectLoading, error: findManyObjectError } = useQuery(FIND_MANY_OBJECTS, {
        fetchPolicy: 'cache-and-network',
        variables: {
            orderBy: getSort(),
            where: {
                publish: { equals: true },
                people: people ? { gte: parseInt(people) } : undefined,
                bed: bed ? { gte: parseInt(bed) } : undefined,
                schedules: {
                    some: {
                        AND: [{
                            status: { equals: true }
                        }, {
                            price: {
                                gte: from ? parseInt(from) : undefined,
                                lte: to ? parseInt(to) : undefined,
                            }
                        }, {
                            OR: date ? [
                                { week: { has: week } },
                                { days: { has: date } }
                            ] : undefined
                        }]
                    }
                },
                company: company ? { is: { id: { in: company } } } : undefined,
                place: place ? { equals: place } : undefined,
                tags: comfort ? { hasSome: comfort } : undefined
            }
        }
    });

    useEffect(() => {
        if (!findManyObjectLoading && findManyObjectData) {
            const mediaQuery = window.matchMedia('(max-width: 768px)')

            if (mediaQuery.matches) {
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.src = `https://link.ykt.ru/session?a=view&p=50933&mode=async&nocache=${new Date().getTime()}`;

                script.onload = () => {
                    // Здесь можно вызвать bcode_p50933(), если она доступна в глобальной области
                    if (typeof bcode_p50933 === 'function') {
                        setTimeout(() => {
                            const div = document.createElement('div');
                            const mainWrap = document.querySelector('#objects-wrap')
                            div.className = 'add-banner'
                            div.innerHTML = bcode_p50933();
                            mainWrap.appendChild(div); // Добавление div в body или в нужное место
                        }, 2000);
                    }
                };

                document.body.appendChild(script); // Добавление скрипта в body

                return () => {
                    // Очистка при размонтировании компонента
                    document.body.removeChild(script);
                };
            }
        }
    }, [findManyObjectLoading, findManyObjectData])

    useEffect(() => {
        const handlerMessage = (e) => {
            if (isJsonString(e?.data)) {
                const data = JSON.parse(e?.data)
                if (data && data.id && data.type && data.type === 'navigate') {
                    if (findManyObjectData) {
                        const { id } = data
                        const object = findManyObjectData?.findManyObject?.filter(object => object.id == id)
                        setSelectedObjectMap(object[0])
                        if (windowWidth < 768)
                            showModal()
                    }
                    // navigation.navigate('Object', { id, date })
                }
            }
        }
        if (window.addEventListener) {
            window.addEventListener('message', handlerMessage);
        } else {
            window.attachEvent('message', handlerMessage);
        }
    }, [findManyObjectData])

    const showModal = () => {
        setModalObjectMap(true);
        Animated.timing(slideAnim, {
            toValue: 0, // Поднимаем окно на экран
            duration: 300,
            useNativeDriver: true,
        }).start();
    };

    const hideModal = () => {
        Animated.timing(slideAnim, {
            toValue: height, // Возвращаем обратно вниз
            duration: 300,
            useNativeDriver: true,
        }).start(() => setModalObjectMap(false)); // Отключаем видимость после анимации
    };
    const squareSize = width > 1024 ? 484 : width - 32

    const findManyObject = findManyObjectData?.findManyObject;


    if (findManyObjectLoading) return <Loading />
    if (findManyObjectError) return <Error />


    const sortItems = [
        {
            label: 'По рейтингу',
            value: 'rating'
        },
        {
            label: 'По цене (возрастание)',
            value: 'priceAsc'
        },
        {
            label: 'По цене (убывание)',
            value: 'priceDesc'
        },
        {
            label: 'По количеству гостей (возрастание)',
            value: 'guestsAsc'
        },
        {
            label: 'По количеству гостей (убывание)',
            value: 'guestsDesc'
        },
    ]


    const comforts = [
        {
            label: 'Отопление',
            value: 'heat'
        },
        {
            label: 'Мангальная зона',
            value: 'grill'
        },
        {
            label: 'Баня/парилка/сауна',
            value: 'bathhouse'
        },
        {
            label: 'Гараж',
            value: 'garage'
        },
        {
            label: 'Портативный гараж',
            value: 'portable garage'
        },
        {
            label: 'Детская площадка',
            value: 'playground'
        },
        {
            label: 'Беседка',
            value: 'gazebo'
        },
        {
            label: 'Бассейн',
            value: 'pool'
        },
        {
            label: 'Рядом с рекой/озером',
            value: 'river'
        },
        {
            label: 'Трансфер',
            value: 'transfer'
        },
        {
            label: 'Можно с питомцами',
            value: 'pet'
        },
        {
            label: 'Кондиционер',
            value: 'conditioner'
        },
        {
            label: 'Wi-Fi',
            value: 'wifi'
        },
        {
            label: 'Санузел',
            value: 'bathroom'
        },
        {
            label: 'Плита для варки',
            value: 'stove'
        },
        {
            label: 'Холодильник',
            value: 'fridge'
        },
        {
            label: 'Микроволновая печь',
            value: 'microwave'
        },
        {
            label: 'Посуда/приборы',
            value: 'dishes'
        },
        {
            label: 'Питьевая вода',
            value: 'water'
        },
        {
            label: 'Караоке',
            value: 'karaoke'
        },
        {
            label: 'Телевизор',
            value: 'tv'
        },
        {
            label: 'Проектор',
            value: 'projector'
        },
        {
            label: 'Игровая зона в доме',
            value: 'gamezone'
        },
        {
            label: 'Постельное белье',
            value: 'bedding'
        },
        {
            label: 'Завтрак включен',
            value: 'breakfast'
        },
    ]

    const places = [
        {
            label: 'г. Якутск',
            value: 'yakutsk'
        },
        {
            label: 'г. Якутск, Вилюйский тракт',
            value: 'vilyuyskiy'
        },
        {
            label: 'г. Якутск, Маганский тракт',
            value: 'maganskiy'
        },
        {
            label: 'г. Якутск, Намский тракт',
            value: 'namskiy'
        },
        {
            label: 'г. Якутск, Намцырский тракт',
            value: 'namtsyrskiy'
        },
        {
            label: 'г. Якутск, Покровский тракт',
            value: 'pokrovskiy'
        },
        {
            label: 'г. Якутск, Хатын-Юряхское шоссе',
            value: 'khatyn-yuryakhskoye'
        },
        {
            label: 'г. Якутск, Сергеляхское шоссе',
            value: 'sergelyakhskoye'
        },
        {
            label: 'г. Якутск, Окружное шоссе',
            value: 'okruzhnoe'
        },
        {
            label: 'г. Якутск, мкр. Птицефабрика',
            value: 'pticefabrika'
        },
        {
            label: 'г. Якутск, мкр. Кангалассы',
            value: 'khangalassy'
        },
        {
            label: 'г. Якутск, с. Пригородный',
            value: 'prigorodniy'
        },
        {
            label: 'г. Якутск, с. Старая Табага',
            value: 'tabaga'
        },
        {
            label: 'г. Якутск, с. Хатассы',
            value: 'khatassy'
        },
        {
            label: 'Амгинский район',
            value: 'amginskiy-rayon'
        },
        {
            label: 'Горный район',
            value: 'gorny-rayon'
        },
        {
            label: 'Мегино-Кангаласский район',
            value: 'megino-kangalasskiy-rayon'
        },
        {
            label: 'Намский район',
            value: 'namskiy-rayon'
        },
        {
            label: 'Нерюнгринский район',
            value: 'nerungrinskiy-rayon'
        },
        {
            label: 'Хангаласский район',
            value: 'khangalasskiy-rayon'
        }
    ]

    const filterObjects = (objects, query) => {
        if (!query) return objects;
        return objects.filter(object =>
            object.name.toLowerCase().includes(query.toLowerCase())
        );
    };

    const markers = findManyObject.filter(object => object.location).map(object => {
        const { pathname } = new URL(object.location)
        const coordinate = pathname?.split('/').reverse()[0]?.split('%2C')
        if (!coordinate) return null
        return {
            id: object.id,
            location: coordinate,
            name: object.name,
            tags: object.tags,
            requests: object.requests,
            schedules: object.schedules,
            place: object.place,
            bed: object.bed,
            people: object.people,
            mapVipRating: object.mapVipRating,
            image: object.images_720.length > 0 ? imageUrl(object.images_720[0]) : imageUrl(object.images[0])
        }
    })

    const objectsMarkers = filterObjects([...markers], debouncedQuery)

    const addToFavorite = (id) => {
        favoritesVar([
            ...new Set([
                ...favoritesVar(),
                id
            ])
        ])
    }

    const removeToFavorite = (id) => {
        const favorites = favoritesVar().filter(object => object !== id)
        favoritesVar([
            ...favorites
        ])
    }

    const getMinPrice = (data) => {
        const prices = data.filter(object => object.status == true).map(object => parseInt(object.price))
        return Math.min(...prices)
    }

    const getMinPriceAndDiscount = (data) => {
        const prices = data.filter(object => object.status == true).map(object => parseInt(object.discount || object.price))
        return Math.min(...prices)
    }

    const getMinDiscount = (data) => {
        const discounts = data.filter(object => object.discount && object.status == true).map(object => parseInt(object.discount))
        if (!discounts || discounts.length === 0) return null
        return Math.min(...discounts)
    }

    const getRating = (requests) => {
        if (requests.length === 0) return (0).toFixed(2)
        const rating = requests.map(object => object.rating).reduce((a = 0, b = 0) => a + b, 0) / requests.length
        if (rating === 0) return (0).toFixed(2)
        return rating.toFixed(2)
    }

    const getTags = (object) => {
        if (object.premium) {
            return (
                <View style={[styles.tagHot, { backgroundColor: '#BCC8B2' }]}>
                    <Text style={styles.hotText}>Интересно</Text>
                </View>
            )
        }
        if (object.hot) {
            return (
                <>
                    <View style={styles.tagHot}>
                        <Text style={styles.hotText}>Горячие</Text>
                    </View>
                    <View style={styles.tagDeadline}>
                        <MaterialCommunityIcons name='history' size={20} color='#000' />
                        <Text style={styles.deadlineText}>осталось 3 дня</Text>
                    </View>
                </>
            )
        }
        return null
    }

    const getPeople = (object) => {
        if (!object.people) return null
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', marginRight: 8 }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="26" viewBox="0 0 23 26" fill="none">
                    <path d="M15.9424 19.5064C15.9424 19.5064 15.4862 19.9626 14.5738 20.875C13.6614 21.7874 11.9189 22.2436 9.34627 22.2436C6.77362 22.2436 4.57491 21.3312 2.75012 19.5064C0.925333 17.6816 0.0129395 15.4829 0.0129395 12.9103C0.0129395 10.3376 0.925333 8.13889 2.75012 6.3141C4.57491 4.48932 6.77362 3.57692 9.34627 3.57692C11.9189 3.57692 14.1176 4.48932 15.9424 6.3141C17.7672 8.13889 18.6796 10.3376 18.6796 12.9103C18.6796 15.4829 17.7672 17.6816 15.9424 19.5064ZM14.9328 7.32372C14.9328 7.32372 14.5477 6.93857 13.7774 6.16827C13.0071 5.39797 11.53 5.01282 9.34627 5.01282C7.16251 5.01282 5.30033 5.78312 3.75973 7.32372C2.21914 8.86432 1.44884 10.7265 1.44884 12.9103C1.44884 15.094 2.21914 16.9562 3.75973 18.4968C5.30033 20.0374 7.16251 20.8077 9.34627 20.8077C11.53 20.8077 13.3922 20.0374 14.9328 18.4968C16.4734 16.9562 17.2437 15.094 17.2437 12.9103C17.2437 10.7265 16.4734 8.86432 14.9328 7.32372ZM14.5065 13.5385C13.9082 14.1966 13.2052 14.5256 12.3976 14.5256C11.5899 14.5256 10.8719 14.1966 10.2437 13.5385C9.64542 12.8803 9.31636 12.1175 9.25653 11.25C9.1967 10.2927 9.46593 9.49252 10.0642 8.84936C10.6625 8.2062 11.4403 7.88461 12.3976 7.88461C13.3249 7.88461 14.0877 8.2062 14.686 8.84936C15.2843 9.49252 15.5535 10.2927 15.4937 11.25C15.4339 12.1175 15.1048 12.8803 14.5065 13.5385ZM5.21807 14.6603C4.88901 14.6603 4.56743 14.5929 4.25332 14.4583C3.93922 14.3237 3.66999 14.1293 3.44563 13.875C3.22127 13.6207 3.02683 13.3216 2.8623 12.9776C2.69777 12.6335 2.60055 12.2821 2.57063 11.9231C2.54072 11.1154 2.78003 10.4423 3.28858 9.90385C3.79713 9.36539 4.44029 9.09615 5.21807 9.09615C5.99585 9.09615 6.63901 9.36539 7.14756 9.90385C7.6561 10.4423 7.88046 11.1154 7.82063 11.9231C7.7608 12.6709 7.47662 13.3141 6.96807 13.8526C6.45952 14.391 5.87619 14.6603 5.21807 14.6603ZM16.7052 17.3526C16.0172 18.5192 14.9552 19.5064 13.5194 20.3141C12.0835 21.1218 10.6924 21.5256 9.34627 21.5256C8.29926 21.5256 7.28217 21.3312 6.29499 20.9423C6.20525 20.703 6.2202 20.3141 6.33986 19.7756C6.66892 18.4893 7.43174 17.4722 8.62832 16.7244C9.70525 16.0662 10.9617 15.7372 12.3976 15.7372C13.8035 15.7372 15.045 16.0662 16.1219 16.7244C16.451 16.9038 16.6454 17.1132 16.7052 17.3526ZM5.21807 19.4167C5.12832 19.7158 5.0685 20.015 5.03858 20.3141L4.99371 20.359C4.33559 19.9701 3.66251 19.3942 2.97448 18.6314C2.28644 17.8686 1.79285 17.1432 1.49371 16.4551C1.79285 16.3654 2.01721 16.2756 2.16679 16.1859C3.03431 15.6474 4.0514 15.3782 5.21807 15.3782C5.93602 15.3782 6.57918 15.4679 7.14756 15.6474C7.29713 15.7073 7.37191 15.812 7.37191 15.9615C7.37191 16.0812 7.32704 16.1859 7.2373 16.2756C6.19029 17.1132 5.51721 18.1603 5.21807 19.4167Z" fill="black" />
                </svg>
                <Text style={{ color: '#000', marginLeft: 4, fontSize: 16 }}>{object.people}</Text>
            </View>
        )
    }

    const getSquare = (square) => {
        if (!square) return null
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', marginRight: 8 }}>
                <Ionicons style={{ marginTop: 1.5 }} name='ios-resize' size={23} color='#101828' />
                <Text style={{ color: '#000', marginLeft: 4, fontSize: 16 }}>{square} м²</Text>
            </View>
        )
    }

    const sortedAndFilteredObjects = filterObjects([...findManyObject], debouncedQuery)
        .sort((current, next) => {
            const currentRequest = current.requests.filter(object => object.rating > 0 && dayjs(object.ratingAt).diff(dayjs(), 'day') <= -3)
            const currentRating = getRating(currentRequest)
            const nextRequest = next.requests.filter(object => object.rating > 0 && dayjs(object.ratingAt).diff(dayjs(), 'day') <= -3)
            const nextRating = getRating(nextRequest)
            const currentReviews = current.requests.filter((object) => object.rating > 0 && dayjs(object.ratingAt).diff(dayjs(), 'day') <= -3);
            const nextReviews = next.requests.filter((object) => object.rating > 0 && dayjs(object.ratingAt).diff(dayjs(), 'day') <= -3);
            if (currentRating !== nextRating) {
                if (currentRating === 4.00 && nextRating === 5.00 && currentReviews.length > nextReviews.length) {
                    return -1
                }
                else if (currentRating === 3.00 && nextRating === 4.00 && currentReviews.length > nextReviews.length) {
                    return -1
                }
                else if (currentRating === 2.00 && nextRating === 3.00 && currentReviews.length > nextReviews.length) {
                    return -1
                }
                else {
                    return nextRating - currentRating
                }
            }
            else {
                if (currentReviews.length !== nextReviews.length) {
                    return nextReviews.length - currentReviews.length
                }
                else {
                    const currentDate = currentRequest.reduce((latestDate, object) => {
                        const reservedDate = dayjs(object.reservedAt);
                        return reservedDate.isAfter(latestDate) ? reservedDate : latestDate;
                    }, dayjs(0));
                    const nextDate = nextRequest.reduce((latestDate, object) => {
                        const reservedDate = dayjs(object.reservedAt);
                        return reservedDate.isAfter(latestDate) ? reservedDate : latestDate;
                    }, dayjs(0));
                    return nextDate.diff(currentDate);
                }
            }
        });

    // const toggleTag = (tag) => {
    //     setSelectedTags(prevTags => {
    //         if (prevTags.includes(tag)) {
    //             return prevTags.filter(t => t !== tag);
    //         } else {
    //             return [...prevTags, tag];
    //         }
    //     });
    // };

    // const findManyObject = findManyObjectData?.findManyObject?.filter(object => {
    //     if (date) {
    //         const fullday = object.requests.filter(
    //             request => request.schedule && request.schedule.fullday && (request.status !== '3' || request.status !== '4')).some(request => dayjs(request?.reservedAt)?.format('DD.MM.YYYY') === date
    //             )
    //         if (fullday) return false

    //         const schedules = object.schedules.filter(schedule => schedule.status == true)
    //         const week = schedules.filter(schedule => schedule.week.some(schedule => schedule.toLowerCase() === dayjs(date, 'DD.MM.YYYY').format('dddd')))
    //         const days = schedules.filter(schedule => schedule.days.some(schedule => schedule === date))

    //         if (week.length === 0 && days.length === 0) return false
    //         const requests = object.requests.filter(request => request.schedule && (request.status !== '3' && request.status !== '4'))
    //         const reserved = requests.filter(request => dayjs(request.reservedAt).format('DD.MM.YYYY') === date)
    //         const closes = schedules.filter(schedule => schedule.closes.some(object => object === date) && schedule.status == true)
    //         if (reserved.length + closes.length === 0) return true
    //         if (((closes.length + reserved.length) >= week.length) && week.length !== 0 || ((closes.length + reserved.length) >= days.length) && days.length !== 0) return false
    //         const weekFullday = week.filter(schedule => !requests.some(request => schedule.fullday || request.scheduleId === schedule.id)).filter(schedule => !schedule.closes.some(object => object === dayjs(date)))
    //         const daysFullday = days.filter(schedule => !requests.some(request => schedule.fullday || request.scheduleId === schedule.id)).filter(schedule => !schedule.closes.some(object => object === dayjs(date)))
    //         if (week.length > 0 && weekFullday.length === 0 || (days.length > 0 && daysFullday.length === 0)) return false
    //         return true
    //     }
    //     return true
    // }) || []


    const filterData = () => {
        let filtered = sortedAndFilteredObjects;

        if (selectedDate !== '') {
            filtered = filtered.filter(object => {
                if ((dayjs(selectedDate) >= dayjs('2025-05-01') && dayjs(selectedDate) <= dayjs('2025-05-02')) || (dayjs(selectedDate) >= dayjs('2025-05-08') && dayjs(selectedDate) <= dayjs('2025-05-09'))) {
                    const fullday = object.requests.filter(
                        request => request.schedule && request.schedule.fullday && (request.status !== '3' || request.status !== '4')).some(request => dayjs(request?.reservedAt)?.format('DD.MM.YYYY') === date
                        )
                    if (fullday) return false

                    const schedules = object.schedules.filter(schedule => schedule.status == true)
                    const openDays = schedules.filter(schedule =>
                        schedule.days.some(d => d === dayjs(selectedDate).format('DD.MM.YYYY'))
                    );
                    if (openDays.length == 0) return false;
                    const requests = object.requests.filter(request => request.schedule && (request.status !== '3' && request.status !== '4'))
                    const reserved = requests.filter(request => dayjs(request.reservedAt).format('DD.MM.YYYY') === formattedDate)
                    const closes = schedules.filter(schedule => schedule.closes.some(close => close === formattedDate) && schedule.status == true)
                    if (reserved.length + closes.length === 0) return true

                    if (reserved.filter(request => request.schedule.fullday).length > 0) return false;
                    if (closes.filter(schedule => schedule.fullday).length > 0) return false;

                    let schedulesLocal = null;
                    if (openDays.length > 0)
                        schedulesLocal = schedules.filter(schedule => (schedule.days.some(object => object === dayjs(selectedDate).format('DD.MM.YYYY'))))
                    else {
                        schedulesLocal = []
                    }
                    if (closes.length >= 2) {
                        let count_day = 0;
                        let count_night = 0;
                        closes.forEach(schedule => {
                            if (schedule.name.toLowerCase().includes('день'))
                                count_day = 1;
                            if (schedule.name.toLowerCase().includes('ночь') || schedule.name.toLowerCase().includes('вечер'))
                                count_night = 1;
                        })
                        if (count_day + count_night == 2) {
                            schedulesLocal = []
                        }
                    }
                    //если закрыт полный день то тарифы не показывает
                    if (schedulesLocal.find(schedule => {
                        const closeSchedule = closes.find(close => schedule.id === close.id)
                        if (closeSchedule?.fullday)
                            return closeSchedule;
                        else
                            return null;
                    }) != null)
                        schedulesLocal = []
                    console.log("YA")
                    const requestsLocal = requests.filter(request => request.reservedAt === selectedDate)
                    //если заявка полный день то сразу закрывает тариф
                    if (requestsLocal.length > 0 && requestsLocal.some(request => { return request.schedule != null && request.schedule.fullday })) {
                        schedulesLocal = []
                    }

                    const currentSchedules = schedulesLocal//.filter((schedule) => (schedule.days.some(day => day === dayjs(selectedDate).format('DD.MM.YYYY'))))
                        .filter(schedule => !requestsLocal.some(request => schedule.fullday || request.scheduleId === schedule.id && !schedule.fullday)) //если полный день или 
                        //если выбранное дата есть в списке закрытых дат то не показывает
                        .filter(schedule => !schedule.closes.some(close => close === dayjs(selectedDate).format('DD.MM.YYYY')))
                        //если день или ночь закрыты то сутки не показываю
                        .filter(schedule => {
                            let count_day = 0;
                            let count_night = 0;
                            closes.forEach(schedule => {
                                if (schedule.name.toLowerCase().includes('день'))
                                    count_day = 1;
                                if (schedule.name.toLowerCase().includes('ночь') || schedule.name.toLowerCase().includes('вечер'))
                                    count_night = 1;
                            })
                            if (count_day + count_night == 0)
                                return schedule
                            else {
                                if (!schedule.fullday)
                                    return schedule
                            }
                        })

                    if (currentSchedules.length == 0)
                        return false

                    return true
                } else {
                    const fullday = object.requests.filter(
                        request => request.schedule && request.schedule.fullday && (request.status !== '3' || request.status !== '4')).some(request => dayjs(request?.reservedAt)?.format('DD.MM.YYYY') === date
                        )
                    if (fullday) return false

                    const schedules = object.schedules.filter(schedule => schedule.status == true)
                    const week = schedules.filter(schedule => schedule.week.some(schedule => schedule.toLowerCase() === dayjs(formattedDate, 'DD.MM.YYYY').format('dddd')))
                    const days = schedules.filter(schedule => schedule.days.some(schedule => schedule === formattedDate))
                    if (week.length === 0 && days.length === 0) return false

                    const requests = object.requests.filter(request => request.schedule && (request.status !== '3' && request.status !== '4'))
                    const reserved = requests.filter(request => dayjs(request.reservedAt).format('DD.MM.YYYY') === formattedDate)
                    const closes = schedules.filter(schedule => schedule.closes.some(close => close === formattedDate) && schedule.status == true)
                    if (reserved.length + closes.length === 0) return true

                    if (reserved.filter(request => request.schedule.fullday).length > 0) return false;

                    if (closes.filter(schedule => schedule.fullday).length > 0) return false;

                    if (((closes.length + reserved.length) >= week.length) && week.length !== 0 || ((closes.length + reserved.length) >= days.length) && days.length !== 0) return false

                    const openDays = schedules.filter(schedule =>
                        schedule.days.some(d => d === dayjs(selectedDate).format('DD.MM.YYYY'))
                    );
                    let schedulesLocal = null;
                    if (openDays.length > 0)
                        schedulesLocal = schedules.filter(schedule => (schedule.days.some(object => object === dayjs(selectedDate).format('DD.MM.YYYY'))))
                    else {
                        if ((dayjs(selectedDate) >= dayjs('2025-05-01') && dayjs(selectedDate) <= dayjs('2025-05-02')) || (dayjs(selectedDate) >= dayjs('2025-05-08') && dayjs(selectedDate) <= dayjs('2025-05-09')))
                            schedulesLocal = []
                        else
                            schedulesLocal = schedules.filter(schedule => (schedule.days.some(object => object === dayjs(selectedDate).format('DD.MM.YYYY')) || schedule.week.some(object => object.toLowerCase() === dayjs(selectedDate).format('dddd'))))
                    }
                    if (closes.length >= 2) {
                        let count_day = 0;
                        let count_night = 0;
                        closes.forEach(schedule => {
                            if (schedule.name.toLowerCase().includes('день'))
                                count_day = 1;
                            if (schedule.name.toLowerCase().includes('ночь') || schedule.name.toLowerCase().includes('вечер'))
                                count_night = 1;
                        })
                        if (count_day + count_night == 2) {
                            schedulesLocal = []
                        }
                    }
                    const weekFullday = week.filter(schedule => !requests.some(request => schedule.fullday || request.scheduleId === schedule.id)).filter(schedule => !schedule.closes.some(object => object === dayjs(formattedDate)))
                    const daysFullday = days.filter(schedule => !requests.some(request => schedule.fullday || request.scheduleId === schedule.id)).filter(schedule => !schedule.closes.some(object => object === dayjs(formattedDate)))

                    // if (week.length > 0 && weekFullday.length === 0 || (days.length > 0 && daysFullday.length === 0)) return false

                    //если закрыт полный день то тарифы не показывает
                    if (schedulesLocal.find(schedule => {
                        const closeSchedule = closes.find(close => schedule.id === close.id)
                        if (closeSchedule?.fullday)
                            return closeSchedule;
                        else
                            return null;
                    }) != null)
                        schedulesLocal = []

                    const requestsLocal = requests.filter(request => request.reservedAt === selectedDate)
                    //если заявка полный день то сразу закрывает тариф
                    if (requestsLocal.length > 0 && requestsLocal.some(request => { return request.schedule != null && request.schedule.fullday })) {
                        schedulesLocal = []
                    }

                    const currentSchedules = schedulesLocal//.filter((schedule) => (schedule.days.some(day => day === dayjs(selectedDate).format('DD.MM.YYYY'))))
                        .filter(schedule => !requestsLocal.some(request => schedule.fullday || request.scheduleId === schedule.id && !schedule.fullday)) //если полный день или 
                        //если выбранное дата есть в списке закрытых дат то не показывает
                        .filter(schedule => !schedule.closes.some(close => close === dayjs(selectedDate).format('DD.MM.YYYY')))
                        //если день или ночь закрыты то сутки не показываю
                        .filter(schedule => {
                            let count_day = 0;
                            let count_night = 0;
                            closes.forEach(schedule => {
                                if (schedule.name.toLowerCase().includes('день'))
                                    count_day = 1;
                                if (schedule.name.toLowerCase().includes('ночь') || schedule.name.toLowerCase().includes('вечер'))
                                    count_night = 1;
                            })
                            if (count_day + count_night == 0)
                                return schedule
                            else {
                                if (!schedule.fullday)
                                    return schedule
                            }
                        })

                    if (currentSchedules.length == 0)
                        return false

                    return true
                }
            });
        }

        if (selectedTags.length > 0) {
            filtered = filtered.filter(object =>
                selectedTags.every(tag => object.tags.includes(tag))
            );
        }

        if (minPrice !== '' || maxPrice !== '') {
            const min = parseInt(minPrice) || 0;
            const max = parseInt(maxPrice) || Infinity;

            filtered = filtered.filter(object => {
                const objectPrice = getMinPrice(object.schedules);
                return objectPrice >= min && objectPrice <= max;
            });
        }

        if (peopleCount !== '') {
            const minPeoples = parseInt(peopleCount);

            filtered = filtered.filter(object => {
                return object.people >= minPeoples;
            });
        }

        if (bedCount !== '') {
            const minBeds = parseInt(bedCount);

            filtered = filtered.filter(object => {
                return object.bed >= minBeds;
            });
        }

        if (selectedPlace.length > 0) {
            filtered = filtered.filter(object => {
                const selectPlaceFilter = selectedPlace.some(place =>
                    object.place == place.value
                )

                return selectPlaceFilter
            });
        }

        switch (sortBy) {
            case 'rating':
                filtered = filtered.sort((a, b) => {
                    const ratingA = getRating(a.requests.filter(req => req.rating > 0 && dayjs(req.ratingAt).diff(dayjs(), 'day') <= -3));
                    const ratingB = getRating(b.requests.filter(req => req.rating > 0 && dayjs(req.ratingAt).diff(dayjs(), 'day') <= -3));
                    return ratingB - ratingA; // Сортировка по убыванию рейтинга
                });
                break;
            case 'priceAsc':
                filtered = filtered.sort((a, b) => getMinPrice(a.schedules) - getMinPrice(b.schedules)); // Сортировка по возрастанию цены
                break;
            case 'priceDesc':
                filtered = filtered.sort((a, b) => getMinPriceAndDiscount(b.schedules) - getMinPriceAndDiscount(a.schedules))
                break;
            case 'guestsAsc':
                filtered = filtered.sort((a, b) => a.people - b.people); // Сортировка по возрастанию количества гостей
                break;
            case 'guestsDesc':
                filtered = filtered.sort((a, b) => b.people - a.people); // Сортировка по убыванию количества гостей
                break;
            default:
                break;
        }

        return filtered;
    };

    const filterDataMap = () => {
        let filtered = objectsMarkers;
        if (selectedDate !== '') {
            filtered = filtered.filter(object => {
                if ((dayjs(selectedDate) >= dayjs('2025-05-01') && dayjs(selectedDate) <= dayjs('2025-05-02')) || (dayjs(selectedDate) >= dayjs('2025-05-08') && dayjs(selectedDate) <= dayjs('2025-05-09'))) {
                    const fullday = object.requests.filter(
                        request => request.schedule && request.schedule.fullday && (request.status !== '3' || request.status !== '4')).some(request => dayjs(request?.reservedAt)?.format('DD.MM.YYYY') === date
                        )
                    if (fullday) return false

                    const schedules = object.schedules.filter(schedule => schedule.status == true)
                    const openDays = schedules.filter(schedule =>
                        schedule.days.some(d => d === dayjs(selectedDate).format('DD.MM.YYYY'))
                    );
                    if (openDays.length == 0) return false;
                    const requests = object.requests.filter(request => request.schedule && (request.status !== '3' && request.status !== '4'))
                    const reserved = requests.filter(request => dayjs(request.reservedAt).format('DD.MM.YYYY') === formattedDate)
                    const closes = schedules.filter(schedule => schedule.closes.some(close => close === formattedDate) && schedule.status == true)
                    if (reserved.length + closes.length === 0) return true

                    if (reserved.filter(request => request.schedule.fullday).length > 0) return false;
                    if (closes.filter(schedule => schedule.fullday).length > 0) return false;

                    let schedulesLocal = null;
                    if (openDays.length > 0)
                        schedulesLocal = schedules.filter(schedule => (schedule.days.some(object => object === dayjs(selectedDate).format('DD.MM.YYYY'))))
                    else {
                        schedulesLocal = []
                    }
                    if (closes.length >= 2) {
                        let count_day = 0;
                        let count_night = 0;
                        closes.forEach(schedule => {
                            if (schedule.name.toLowerCase().includes('день'))
                                count_day = 1;
                            if (schedule.name.toLowerCase().includes('ночь') || schedule.name.toLowerCase().includes('вечер'))
                                count_night = 1;
                        })
                        if (count_day + count_night == 2) {
                            schedulesLocal = []
                        }
                    }
                    //если закрыт полный день то тарифы не показывает
                    if (schedulesLocal.find(schedule => {
                        const closeSchedule = closes.find(close => schedule.id === close.id)
                        if (closeSchedule?.fullday)
                            return closeSchedule;
                        else
                            return null;
                    }) != null)
                        schedulesLocal = []
                    console.log("YA")
                    const requestsLocal = requests.filter(request => request.reservedAt === selectedDate)
                    //если заявка полный день то сразу закрывает тариф
                    if (requestsLocal.length > 0 && requestsLocal.some(request => { return request.schedule != null && request.schedule.fullday })) {
                        schedulesLocal = []
                    }

                    const currentSchedules = schedulesLocal//.filter((schedule) => (schedule.days.some(day => day === dayjs(selectedDate).format('DD.MM.YYYY'))))
                        .filter(schedule => !requestsLocal.some(request => schedule.fullday || request.scheduleId === schedule.id && !schedule.fullday)) //если полный день или 
                        //если выбранное дата есть в списке закрытых дат то не показывает
                        .filter(schedule => !schedule.closes.some(close => close === dayjs(selectedDate).format('DD.MM.YYYY')))
                        //если день или ночь закрыты то сутки не показываю
                        .filter(schedule => {
                            let count_day = 0;
                            let count_night = 0;
                            closes.forEach(schedule => {
                                if (schedule.name.toLowerCase().includes('день'))
                                    count_day = 1;
                                if (schedule.name.toLowerCase().includes('ночь') || schedule.name.toLowerCase().includes('вечер'))
                                    count_night = 1;
                            })
                            if (count_day + count_night == 0)
                                return schedule
                            else {
                                if (!schedule.fullday)
                                    return schedule
                            }
                        })

                    if (currentSchedules.length == 0)
                        return false

                    return true
                } else {
                    const fullday = object.requests.filter(
                        request => request.schedule && request.schedule.fullday && (request.status !== '3' || request.status !== '4')).some(request => dayjs(request?.reservedAt)?.format('DD.MM.YYYY') === date
                        )
                    if (fullday) return false

                    const schedules = object.schedules.filter(schedule => schedule.status == true)
                    const week = schedules.filter(schedule => schedule.week.some(schedule => schedule.toLowerCase() === dayjs(formattedDate, 'DD.MM.YYYY').format('dddd')))
                    const days = schedules.filter(schedule => schedule.days.some(schedule => schedule === formattedDate))
                    if (week.length === 0 && days.length === 0) return false

                    const requests = object.requests.filter(request => request.schedule && (request.status !== '3' && request.status !== '4'))
                    const reserved = requests.filter(request => dayjs(request.reservedAt).format('DD.MM.YYYY') === formattedDate)
                    const closes = schedules.filter(schedule => schedule.closes.some(close => close === formattedDate))

                    if (reserved.length + closes.length === 0) return true

                    if (reserved.filter(request => request.schedule.fullday).length > 0) return false;

                    if (closes.filter(schedule => schedule.fullday).length > 0) return false;

                    if (((closes.length + reserved.length) >= week.length) && week.length !== 0 || ((closes.length + reserved.length) >= days.length) && days.length !== 0) return false

                    const openDays = schedules.filter(schedule =>
                        schedule.days.some(d => d === dayjs(selectedDate).format('DD.MM.YYYY'))
                    );
                    let schedulesLocal = null;
                    if (openDays.length > 0)
                        schedulesLocal = schedules.filter(schedule => (schedule.days.some(object => object === dayjs(selectedDate).format('DD.MM.YYYY'))))
                    else {
                        schedulesLocal = schedules.filter(schedule => (schedule.days.some(object => object === dayjs(selectedDate).format('DD.MM.YYYY')) || schedule.week.some(object => object.toLowerCase() === dayjs(selectedDate).format('dddd'))))
                    }
                    if (closes.length >= 2) {
                        let count_day = 0;
                        let count_night = 0;
                        closes.forEach(schedule => {
                            if (schedule.name.toLowerCase().includes('день'))
                                count_day = 1;
                            if (schedule.name.toLowerCase().includes('ночь') || schedule.name.toLowerCase().includes('вечер'))
                                count_night = 1;
                        })
                        if (count_day + count_night == 2) {
                            schedulesLocal = []
                        }
                    }

                    const weekFullday = week.filter(schedule => !requests.some(request => schedule.fullday || request.scheduleId === schedule.id)).filter(schedule => !schedule.closes.some(object => object === dayjs(formattedDate)))
                    const daysFullday = days.filter(schedule => !requests.some(request => schedule.fullday || request.scheduleId === schedule.id)).filter(schedule => !schedule.closes.some(object => object === dayjs(formattedDate)))

                    // if (week.length > 0 && weekFullday.length === 0 || (days.length > 0 && daysFullday.length === 0)) return false

                    //если закрыт полный день то тарифы не показывает
                    if (schedulesLocal.find(schedule => {
                        const closeSchedule = closes.find(close => schedule.id === close.id)
                        if (closeSchedule?.fullday)
                            return closeSchedule;
                        else
                            return null;
                    }) != null)
                        schedulesLocal = []

                    const requestsLocal = requests.filter(request => request.reservedAt === selectedDate)
                    //если заявка полный день то сразу закрывает тариф
                    if (requestsLocal.length > 0 && requestsLocal.some(request => { return request.schedule != null && request.schedule.fullday })) {
                        schedulesLocal = []
                    }

                    const currentSchedules = schedulesLocal//.filter((schedule) => (schedule.days.some(day => day === dayjs(selectedDate).format('DD.MM.YYYY'))))
                        .filter(schedule => !requestsLocal.some(request => schedule.fullday || request.scheduleId === schedule.id && !schedule.fullday)) //если полный день или 
                        //если выбранное дата есть в списке закрытых дат то не показывает
                        .filter(schedule => !schedule.closes.some(close => close === dayjs(selectedDate).format('DD.MM.YYYY')))
                        //если день или ночь закрыты то сутки не показываю
                        .filter(schedule => {
                            let count_day = 0;
                            let count_night = 0;
                            closes.forEach(schedule => {
                                if (schedule.name.toLowerCase().includes('день'))
                                    count_day = 1;
                                if (schedule.name.toLowerCase().includes('ночь') || schedule.name.toLowerCase().includes('вечер'))
                                    count_night = 1;
                            })
                            if (count_day + count_night == 0)
                                return schedule
                            else {
                                if (!schedule.fullday)
                                    return schedule
                            }
                        })

                    if (currentSchedules.length == 0)
                        return false

                    return true
                }
            });
        }

        if (selectedTags.length > 0) {
            filtered = filtered.filter(object =>
                selectedTags.every(tag => object.tags.includes(tag))
            );
        }

        if (minPrice !== '' || maxPrice !== '') {
            const min = parseInt(minPrice) || 0;
            const max = parseInt(maxPrice) || Infinity;

            filtered = filtered.filter(object => {
                const objectPrice = getMinPrice(object.schedules);
                return objectPrice >= min && objectPrice <= max;
            });
        }

        if (peopleCount !== '') {
            const minPeoples = parseInt(peopleCount);

            filtered = filtered.filter(object => {
                return object.people >= minPeoples;
            });
        }

        if (bedCount !== '') {
            const minBeds = parseInt(bedCount);

            filtered = filtered.filter(object => {
                return object.bed >= minBeds;
            });
        }

        if (selectedPlace.length > 0) {
            filtered = filtered.filter(object => {
                const selectPlaceFilter = selectedPlace.some(place =>
                    object.place == place.value
                )

                return selectPlaceFilter
            });
        }

        return filtered;
    };

    function choiceConvenience(selectedTags) {
        setSelectedTags(prevTags => {
            if (prevTags.includes(selectedTags.value)) {
                return prevTags.filter(t => t !== selectedTags.value);
            } else {
                return [...prevTags, selectedTags.value];
            }
        });

        if (convenience.includes(selectedTags.value)) {
            setConvenience(convenience.filter(Convenience => Convenience !== selectedTags.value))
            return;
        }

        setConvenience(prevConvenience => [...prevConvenience, selectedTags.value])
    }

    const getDisabledDates = (today) => {
        const disabledDates = {};
        const currentDate = dayjs(today);

        for (let i = 1; i <= 365; i++) {
            const date = currentDate.subtract(i, 'day').format('YYYY-MM-DD');
            disabledDates[date] = { disabled: true };
        }

        return disabledDates;
    };

    const handleSearch = () => {
        if (minPrice === '' && maxPrice === '' && bedCount === '' && selectedTags.length === 0) {
            // Если фильтры не заданы, показываем все элементы
            setFilteredObjects(sortedAndFilteredObjects);
        } else {
            const results = filterData(sortedAndFilteredObjects);
            setFilteredObjects(results);
        }

        setModalFilter(false);
    };

    const handleReset = () => {
        let bedCountReset = ''
        let minPriceReset = ''
        let maxPriceReset = ''
        let selectedTagsReset = []
        let convenienceReset = []

        setBedCount(bedCountReset)
        setMinPrice(minPriceReset)
        setMaxPrice(maxPriceReset)
        setSelectedTags(selectedTagsReset)
        setConvenience(convenienceReset)
        setSelectedDate('')
        setSelectedPlace('')
        setFormattedDate('')
        setDateFilter('')
        setPeopleCount('')
        setPeopleFilter('')

        setModalFilter(false);
    };

    // const handleResetSearch = () => {

    // }

    const handleSortChange = (sortOption) => {
        setSortBy(sortOption);
        // Обновите фильтрацию при изменении сортировки
        const results = filterData(sortedAndFilteredObjects);
        setFilteredObjects(results);
    };

    const handleToggle = () => {
        setIsExpanded(!isExpanded);
    };

    const handleShowFilterCalendar = () => {
        setShowFilterCalendar(!showFilterCalendar);
    };

    const handleCloseCalendarFilter = () => {
        setSelectedDate('');
        setFormattedDate('')
        setDateFilter('')
    };

    const handleClosePriceFilter = () => {
        setMinPrice('');
        setMaxPrice('');
    }

    const handleSelectSearchList = (object) => {
        setSearchQuery(object.name)
        setIsSearchListVisible(false);

        const handler = setTimeout(() => {
            setDebouncedQuery(object.name);
        }, 400);

        return () => {
            clearTimeout(handler);
        };
    }

    const handleClosePeopleCountFilter = () => {
        setPeopleCount('')
        setPeopleFilter('')
    }

    const handleCloseBedCountFilter = () => {
        setBedCount('')
    }

    const handleCloseSelectedTagsFilter = (tagToRemove) => {
        setSelectedTags(prevTags => prevTags.filter(tag => tag !== tagToRemove));
        setConvenience(prevTags => prevTags.filter(tag => tag !== tagToRemove));
    };

    const handleCloseSelectedPlaceFilter = (tagToRemove) => {
        setSelectedPlace(prevTags => prevTags.filter(tag => tag !== tagToRemove));
    };

    const handleMinPrice = (text) => {
        const numericValue = text.replace(/[^0-9]/g, '');
        setMinPrice(numericValue)
    }

    const handleMaxPrice = (text) => {
        const numericValue = text.replace(/[^0-9]/g, '');
        setMaxPrice(numericValue)
    }

    const handlePeopleCount = (text) => {
        const numericValue = text.replace(/[^0-9]/g, '');
        setPeopleCount(numericValue)
        setPeopleFilter(numericValue)
    }

    const handleBedCount = (text) => {
        const numericValue = text.replace(/[^0-9]/g, '');
        setBedCount(numericValue)
    }

    const selectCalendar = (day) => {
        setSelectedDate(day.dateString);
        setDateFilter(day.dateString)
    }

    function setModeList() {
        setMode('list');
        setSelectedObjectMap(null);
        if (window.location.hash) {
            window.history.replaceState("", document.title, window.location.pathname);
        }
    }

    const handleScroll = (event) => {
        const offsetY = event.nativeEvent.contentOffset.y;

        const addDiv = document.querySelectorAll('.add-header')

        if (offsetY > 0) {
            if (addDiv) {
                addDiv.forEach(add => {
                    add.style.height = 0 + 'px';
                    add.style.opacity = 0;
                })
            }
        } else {
            if (addDiv) {
                addDiv.forEach(add => {
                    add.style.height = 180 + 'px';
                    add.style.opacity = 1;
                })
            }
        }
    };

    if (mode === 'map') {
        return (
            <>
                <Window style={{ position: 'absolute', width: 'auto', top: windowWidth > 768 ? 80 : 24, zIndex: 5 }}>
                    {/* <TouchableOpacity onPress={() => navigation.navigate('Filter', { type: 'objects', from, to, date, people, place, bed, heat, sort, comfort: JSON.stringify(comfort), company: JSON.stringify(company) })} style={styles.searchContainer}>
                        <Ionicons style={styles.searchIcon} name='ios-search' size={24} />
                        <View>
                            <Text style={styles.searchTitle}>Найти мwefwefесто для отдыха?</Text>
                            <Text style={styles.searchText}>Поиск по дате, фильтр и сортировка</Text>
                        </View>
                    </TouchableOpacity> */}
                    <View style={styles.mapFilterHeader}>
                        <View style={styles.searchWrap}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="27" viewBox="0 0 24 27" fill="none">
                                <path d="M21.3873 21.1126C21.5741 21.3617 21.6675 21.6264 21.6675 21.9066C21.6675 22.2179 21.5508 22.4904 21.3172 22.7239C21.0837 22.9574 20.8113 23.0742 20.4999 23.0742C20.2197 23.0742 19.9551 22.9808 19.706 22.794L15.3159 18.4038C15.0356 18.6218 14.6854 18.832 14.265 19.0343C13.8447 19.2367 13.4244 19.408 13.0041 19.5481C12.5837 19.6882 12.1478 19.7972 11.6964 19.875C11.2449 19.9528 10.8323 19.9918 10.4587 19.9918C8.18583 19.9918 6.25542 19.1978 4.66751 17.6099C3.0796 16.022 2.28564 14.0994 2.28564 11.842C2.28564 9.5847 3.0796 7.66208 4.66751 6.07417C6.25542 4.48626 8.17804 3.6923 10.4354 3.6923C12.6927 3.6923 14.6153 4.48626 16.2032 6.07417C17.7911 7.66208 18.5851 9.59249 18.5851 11.8654C18.5851 12.6126 18.4294 13.4611 18.1181 14.4107C17.8067 15.3603 17.4331 16.1309 16.9972 16.7225L21.3873 21.1126ZM6.32548 7.73214C6.32548 7.73214 6.04137 8.01625 5.47314 8.58447C4.90492 9.1527 4.62081 10.2386 4.62081 11.842C4.62081 13.4455 5.18903 14.8155 6.32548 15.9519C7.46193 17.0884 8.83189 17.6644 10.4354 17.6799C12.0388 17.6955 13.4166 17.1273 14.5686 15.9753C15.7206 14.8233 16.2966 13.4455 16.2966 11.842C16.2966 10.2386 15.7206 8.86859 14.5686 7.73214C13.4166 6.59569 12.0388 6.02747 10.4354 6.02747C8.83189 6.02747 7.46193 6.59569 6.32548 7.73214Z" fill="black" />
                            </svg>
                            <TextInput
                                style={styles.searchInput}
                                placeholder="Поиск по названию"
                                value={searchQuery}
                                onChangeText={(text) => setSearchQuery(text)}
                                placeholderTextColor="#6B7280"
                                onFocus={() => {
                                    setIsSearchListVisible(true);
                                }}
                                onBlur={() => {
                                    setTimeout(() => {
                                        setIsSearchListVisible(false);
                                    }, 200);
                                }}
                            />
                        </View>
                        <TouchableOpacity
                            onPress={() => setModalFilter(true)}
                            style={[styles.filterBtn, { maxWidth: 122, width: '100%' }]}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M2.50008 6.33334H3.68675C3.85986 6.87731 4.20154 7.35212 4.66235 7.68906C5.12317 8.026 5.67922 8.2076 6.25008 8.2076C6.82094 8.2076 7.377 8.026 7.83781 7.68906C8.29863 7.35212 8.6403 6.87731 8.81342 6.33334H17.5001C17.7211 6.33334 17.9331 6.24554 18.0893 6.08926C18.2456 5.93298 18.3334 5.72102 18.3334 5.5C18.3334 5.27899 18.2456 5.06703 18.0893 4.91075C17.9331 4.75447 17.7211 4.66667 17.5001 4.66667H8.81342C8.6403 4.12269 8.29863 3.64789 7.83781 3.31095C7.377 2.97401 6.82094 2.7924 6.25008 2.7924C5.67922 2.7924 5.12317 2.97401 4.66235 3.31095C4.20154 3.64789 3.85986 4.12269 3.68675 4.66667H2.50008C2.27907 4.66667 2.06711 4.75447 1.91083 4.91075C1.75455 5.06703 1.66675 5.27899 1.66675 5.5C1.66675 5.72102 1.75455 5.93298 1.91083 6.08926C2.06711 6.24554 2.27907 6.33334 2.50008 6.33334Z" fill="#1F2A37" />
                                <path d="M17.5001 9.66667H16.3134C16.1403 9.12269 15.7986 8.64789 15.3378 8.31095C14.877 7.97401 14.3209 7.7924 13.7501 7.7924C13.1792 7.7924 12.6232 7.97401 12.1624 8.31095C11.7015 8.64789 11.3599 9.12269 11.1867 9.66667H2.50008C2.27907 9.66667 2.06711 9.75447 1.91083 9.91075C1.75455 10.067 1.66675 10.279 1.66675 10.5C1.66675 10.721 1.75455 10.933 1.91083 11.0893C2.06711 11.2455 2.27907 11.3333 2.50008 11.3333H11.1867C11.3599 11.8773 11.7015 12.3521 12.1624 12.6891C12.6232 13.026 13.1792 13.2076 13.7501 13.2076C14.3209 13.2076 14.877 13.026 15.3378 12.6891C15.7986 12.3521 16.1403 11.8773 16.3134 11.3333H17.5001C17.7211 11.3333 17.9331 11.2455 18.0893 11.0893C18.2456 10.933 18.3334 10.721 18.3334 10.5C18.3334 10.279 18.2456 10.067 18.0893 9.91075C17.9331 9.75447 17.7211 9.66667 17.5001 9.66667Z" fill="#1F2A37" />
                                <path d="M17.5001 14.6667H8.81342C8.6403 14.1227 8.29863 13.6479 7.83781 13.311C7.377 12.974 6.82094 12.7924 6.25008 12.7924C5.67922 12.7924 5.12317 12.974 4.66235 13.311C4.20154 13.6479 3.85986 14.1227 3.68675 14.6667H2.50008C2.27907 14.6667 2.06711 14.7545 1.91083 14.9107C1.75455 15.067 1.66675 15.279 1.66675 15.5C1.66675 15.721 1.75455 15.933 1.91083 16.0893C2.06711 16.2455 2.27907 16.3333 2.50008 16.3333H3.68675C3.85986 16.8773 4.20154 17.3521 4.66235 17.6891C5.12317 18.026 5.67922 18.2076 6.25008 18.2076C6.82094 18.2076 7.377 18.026 7.83781 17.6891C8.29863 17.3521 8.6403 16.8773 8.81342 16.3333H17.5001C17.7211 16.3333 17.9331 16.2455 18.0893 16.0893C18.2456 15.933 18.3334 15.721 18.3334 15.5C18.3334 15.279 18.2456 15.067 18.0893 14.9107C17.9331 14.7545 17.7211 14.6667 17.5001 14.6667Z" fill="#1F2A37" />
                            </svg>
                            <Text style={styles.filterBtnTextTwo}>
                                Фильтры
                            </Text>
                        </TouchableOpacity>
                    </View>
                    {
                        searchQuery.length > 0 && filterData(sortedAndFilteredObjects).length > 0 && isSearchListVisible && (
                            <View style={{ paddingHorizontal: 16, marginHorizontal: 8 }}>
                                <View style={[styles.searchList, { top: 12 }]}>
                                    {
                                        filterData(sortedAndFilteredObjects).slice(0, 7).map((object, index) => (
                                            <TouchableOpacity
                                                style={styles.searchListItem}
                                                onPress={() => handleSelectSearchList(object)}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M17.2892 9.46966L15.7874 7.96965L10.5309 2.71959C10.3901 2.57899 10.1991 2.5 10 2.5C9.80088 2.5 9.60992 2.57899 9.4691 2.71959L4.21264 7.96965L2.71079 9.46966C2.57401 9.61112 2.49832 9.80057 2.50003 9.99722C2.50174 10.1939 2.58071 10.382 2.71994 10.521C2.85917 10.6601 3.04751 10.739 3.2444 10.7407C3.44129 10.7424 3.63097 10.6668 3.7726 10.5302L3.99262 10.3104V16C3.99262 16.3978 4.15085 16.7793 4.4325 17.0607C4.71415 17.342 5.09615 17.5 5.49446 17.5H8.49815C8.69731 17.5 8.88831 17.421 9.02914 17.2803C9.16996 17.1397 9.24908 16.9489 9.24908 16.75V13H10.7509V16.75C10.7509 16.9489 10.83 17.1397 10.9709 17.2803C11.1117 17.421 11.3027 17.5 11.5018 17.5H14.5055C14.9039 17.5 15.2858 17.342 15.5675 17.0607C15.8492 16.7793 16.0074 16.3978 16.0074 16V10.3104L16.2274 10.5302C16.369 10.6668 16.5587 10.7424 16.7556 10.7407C16.9525 10.739 17.1408 10.6601 17.2801 10.521C17.4193 10.382 17.4983 10.1939 17.5 9.99722C17.5017 9.80057 17.426 9.61112 17.2892 9.46966ZM14.5055 16H12.2528V13C12.2528 12.6021 12.0945 12.2206 11.8129 11.9393C11.5312 11.658 11.1492 11.4999 10.7509 11.4999H9.24908C8.85076 11.4999 8.46876 11.658 8.18711 11.9393C7.90546 12.2206 7.74723 12.6021 7.74723 13V16H5.49446V8.81041L10 4.31036L14.5055 8.81041V16Z" fill="#374151" />
                                                </svg>
                                                <Text>{object.name}</Text>
                                            </TouchableOpacity>
                                        ))
                                    }
                                </View>
                            </View>
                        )
                    }
                    {
                        filterData(sortedAndFilteredObjects).length > 0 ? <View style={[styles.filterSelectsWrap, { marginTop: 8, marginBottom: 0, marginStart: 8 }]}>
                            {
                                selectedDate.length > 0 && (
                                    <View style={styles.filterSelectItem}>
                                        <TouchableOpacity onPress={() => setModalFilter(true)}>
                                            <Text style={styles.filterSelectItemText}>{formattedDate}</Text>
                                        </TouchableOpacity>
                                        <TouchableOpacity onPress={handleCloseCalendarFilter}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512"><path fill="currentColor" d="m289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34Z" />
                                            </svg>
                                        </TouchableOpacity>
                                    </View>
                                )
                            }
                            {(minPrice && maxPrice) || (minPrice.length > 0 || maxPrice.length > 0) ? (
                                <View style={styles.filterSelectItem}>
                                    <TouchableOpacity onPress={() => setModalFilter(true)}>
                                        <Text style={styles.filterSelectItemText}>
                                            {
                                                minPrice.length > 0 && (
                                                    'От ' + minPrice + ' ₽ '
                                                )
                                            }
                                            {
                                                maxPrice.length > 0 && (
                                                    'до ' + maxPrice + ' ₽'
                                                )
                                            }
                                        </Text>
                                    </TouchableOpacity>
                                    <TouchableOpacity onPress={handleClosePriceFilter}>
                                        {/* Использование SVG для кнопки закрытия */}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512">
                                            <path fill="currentColor" d="m289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34Z" />
                                        </svg>
                                    </TouchableOpacity>
                                </View>
                            ) : null}
                            {
                                peopleCount.length > 0 && (
                                    <View style={styles.filterSelectItem}>
                                        <TouchableOpacity onPress={() => setModalFilter(true)}>
                                            <Text style={styles.filterSelectItemText}>{peopleCount} гостей</Text>
                                        </TouchableOpacity>
                                        <TouchableOpacity onPress={handleClosePeopleCountFilter}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512"><path fill="currentColor" d="m289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34Z" />
                                            </svg>
                                        </TouchableOpacity>
                                    </View>
                                )
                            }
                            {
                                bedCount.length > 0 && (
                                    <View style={styles.filterSelectItem}>
                                        <TouchableOpacity onPress={() => setModalFilter(true)}>
                                            <Text style={styles.filterSelectItemText}>{bedCount} сп. мест</Text>
                                        </TouchableOpacity>
                                        <TouchableOpacity onPress={handleCloseBedCountFilter}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512"><path fill="currentColor" d="m289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34Z" />
                                            </svg>
                                        </TouchableOpacity>
                                    </View>
                                )
                            }
                            {
                                selectedTags.length > 0 && (
                                    selectedTags.map(selectedTag => (
                                        <View key={selectedTag} style={styles.filterSelectItem}>
                                            {
                                                comforts.map(comfort => (
                                                    comfort.value == selectedTag && (
                                                        <TouchableOpacity onPress={() => setModalFilter(true)}>
                                                            <Text key={comfort.value} style={styles.filterSelectItemText}>{comfort.label}</Text>
                                                        </TouchableOpacity>
                                                    )
                                                ))
                                            }
                                            <TouchableOpacity onPress={() => handleCloseSelectedTagsFilter(selectedTag)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512"><path fill="currentColor" d="m289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34Z" />
                                                </svg>
                                            </TouchableOpacity>
                                        </View>
                                    ))
                                )
                            }
                            {
                                selectedPlace.length > 0 && (
                                    selectedPlace.map(place => (
                                        <View key={place} style={styles.filterSelectItem}>
                                            <TouchableOpacity onPress={() => setModalFilter(true)}>
                                                <Text>{place.label}</Text>
                                            </TouchableOpacity>
                                            <TouchableOpacity onPress={() => handleCloseSelectedPlaceFilter(place)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512"><path fill="currentColor" d="m289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34Z" />
                                                </svg>
                                            </TouchableOpacity>
                                        </View>
                                    ))
                                )
                            }
                        </View> : null
                    }
                </Window>
                <Map markers={filterDataMap(objectsMarkers)} />
                {
                    selectedObjectMap ?
                        windowWidth < 768 ?
                            <Modal transparent visible={modalObjectMap} animationType="none">
                                <Pressable style={styles.modalObjectInfoBackground} onPress={hideModal}>
                                    <Animated.View
                                        style={[
                                            styles.modalObjectInfoContainer,
                                            { transform: [{ translateY: slideAnim }] },
                                        ]}
                                    >
                                        <View style={styles.modalObjectInfoContent}>
                                            <TouchableOpacity onPress={() => { openObject(selectedObjectMap.id, selectedDate ? dayjs(selectedDate).format('DD.MM.YYYY') : ''); hideModal(); }}>
                                                <View style={{ flexDirection: 'column' }}>
                                                    <ImageBackground style={[styles.objectImage, { height: 200, width: 200 }]} source={selectedObjectMap.images_720.length > 0 ? { uri: imageUrl(selectedObjectMap.images_720[0]) } : { uri: imageUrl(selectedObjectMap.images[0]) }}>
                                                        {
                                                            user ? (
                                                                <>
                                                                    {
                                                                        selectedObjectMap.favorite ? (
                                                                            <TouchableOpacity onPress={() => removeToFavorite(selectedObjectMap.id)} style={styles.favoriteMap}>
                                                                                <Ionicons name='ios-heart-sharp' size={16} color='#475467' />
                                                                            </TouchableOpacity>
                                                                        ) : (
                                                                            <TouchableOpacity onPress={() => addToFavorite(selectedObjectMap.id)} style={styles.favoriteMap}>
                                                                                <Ionicons name='ios-heart-outline' size={16} color='#475467' />
                                                                            </TouchableOpacity>
                                                                        )
                                                                    }
                                                                </>
                                                            ) : <View />
                                                        }
                                                        <View style={styles.tagsContainer}>
                                                            {
                                                                getTags(selectedObjectMap)
                                                            }
                                                        </View>
                                                    </ImageBackground>
                                                    <View>
                                                        <View style={[styles.infoContainer, { justifyContent: 'space-between', marginTop: 8, alignItems: 'center' }]}>
                                                            <Text style={[styles.infoTitle, { maxWidth: 200 }]}>{selectedObjectMap.name}</Text>

                                                        </View>
                                                        <View style={[styles.infoGroup, { maxWidth: 200 }]}>
                                                            {
                                                                getPeople(selectedObjectMap)
                                                            }
                                                            {
                                                                getSquare(selectedObjectMap.square)
                                                            }
                                                            {getRating(selectedObjectMap.requests.filter(request => request.rating > 0 && dayjs(request.ratingAt).diff(dayjs(), 'day') <= -3)) > 0 ?
                                                                <View style={[styles.infoContainer, { justifyContent: 'space-between', alignItems: 'center' }]}>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
                                                                        <path d="M14.6923 19.7885C14.5641 19.7885 14.4487 19.75 14.3461 19.6731L9.38458 16.0961L4.42304 19.6731C4.32048 19.75 4.20509 19.7885 4.07689 19.7885C3.8974 19.7885 3.74996 19.7308 3.63458 19.6154C3.51919 19.5 3.4615 19.3526 3.4615 19.1731C3.4615 19.0961 3.47432 19.032 3.49996 18.9808L5.42304 13.25L0.423039 9.82691C0.243552 9.69871 0.153809 9.53204 0.153809 9.32691C0.153809 9.14743 0.211501 8.99999 0.326886 8.88461C0.44227 8.76922 0.589706 8.71153 0.769193 8.71153H6.92304L8.80766 2.98076C8.88458 2.69871 9.07689 2.55768 9.38458 2.55768C9.69227 2.55768 9.88458 2.69871 9.9615 2.98076L11.8461 8.71153H18C18.1795 8.71153 18.3269 8.76922 18.4423 8.88461C18.5577 8.99999 18.6153 9.14743 18.6153 9.32691C18.6153 9.53204 18.5256 9.69871 18.3461 9.82691L13.3461 13.25L15.2692 18.9808C15.2948 19.032 15.3077 19.0961 15.3077 19.1731C15.3077 19.3526 15.25 19.5 15.1346 19.6154C15.0192 19.7308 14.8718 19.7885 14.6923 19.7885Z" fill="black" />
                                                                    </svg>
                                                                    <Text style={styles.rate}>{getRating(selectedObjectMap.requests.filter(request => request.rating > 0 && dayjs(request.ratingAt).diff(dayjs(), 'day') <= -3))}</Text>
                                                                </View> : ""}
                                                        </View>
                                                        {
                                                            getMinDiscount(selectedObjectMap.schedules) && getMinPrice(selectedObjectMap.schedules) > getMinDiscount(selectedObjectMap.schedules) ? (
                                                                <View style={{ flexDirection: 'row' }}>
                                                                    <Text style={styles.price}>от </Text>
                                                                    <Text style={[styles.price, { textDecorationLine: 'line-through', color: '#667085', fontWeight: '400' }]}>{getMinPrice(selectedObjectMap.schedules)} ₽</Text>
                                                                    <Text style={styles.price}> {getMinDiscount(selectedObjectMap.schedules)} ₽</Text>
                                                                </View>
                                                            ) : (
                                                                <Text style={styles.price}>от {getMinPrice(selectedObjectMap.schedules)} ₽</Text>
                                                            )
                                                        }
                                                    </View>
                                                </View>
                                            </TouchableOpacity>
                                        </View>
                                    </Animated.View>
                                </Pressable>
                            </Modal>
                            :
                            <View style={{
                                backgroundColor: '#ffff',
                                width: 250,
                                height: '100%',
                                position: 'absolute', //Here is the trick
                                bottom: 0,
                                alignItems: 'center',
                                alignSelf: 'flex-end',
                                paddingTop: 20,
                            }}>
                                <TouchableOpacity onPress={() => openObject(selectedObjectMap.id, selectedDate ? dayjs(selectedDate).format('DD.MM.YYYY') : '')}>
                                    <View style={{ flexDirection: 'column' }}>
                                        <ImageBackground style={[styles.objectImage, { height: 200, width: 200 }]} source={selectedObjectMap.images_720.length > 0 ? { uri: imageUrl(selectedObjectMap.images_720[0]) } : { uri: imageUrl(selectedObjectMap.images[0]) }}>
                                            {
                                                user ? (
                                                    <>
                                                        {
                                                            selectedObjectMap.favorite ? (
                                                                <TouchableOpacity onPress={() => removeToFavorite(selectedObjectMap.id)} style={styles.favoriteMap}>
                                                                    <Ionicons name='ios-heart-sharp' size={16} color='#475467' />
                                                                </TouchableOpacity>
                                                            ) : (
                                                                <TouchableOpacity onPress={() => addToFavorite(selectedObjectMap.id)} style={styles.favoriteMap}>
                                                                    <Ionicons name='ios-heart-outline' size={16} color='#475467' />
                                                                </TouchableOpacity>
                                                            )
                                                        }
                                                    </>
                                                ) : <View />
                                            }
                                            <View style={styles.tagsContainer}>
                                                {
                                                    getTags(selectedObjectMap)
                                                }
                                            </View>
                                        </ImageBackground>
                                        <View>
                                            <View style={[styles.infoContainer, { justifyContent: 'space-between', marginTop: 8, alignItems: 'center' }]}>
                                                <Text style={[styles.infoTitle, { maxWidth: 200 }]}>{selectedObjectMap.name}</Text>

                                            </View>
                                            <View style={[styles.infoGroup, { maxWidth: 200 }]}>
                                                {
                                                    getPeople(selectedObjectMap)
                                                }
                                                {
                                                    getSquare(selectedObjectMap.square)
                                                }
                                                {getRating(selectedObjectMap.requests.filter(request => request.rating > 0 && dayjs(request.ratingAt).diff(dayjs(), 'day') <= -3)) > 0 ?
                                                    <View style={[styles.infoContainer, { justifyContent: 'space-between', alignItems: 'center' }]}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
                                                            <path d="M14.6923 19.7885C14.5641 19.7885 14.4487 19.75 14.3461 19.6731L9.38458 16.0961L4.42304 19.6731C4.32048 19.75 4.20509 19.7885 4.07689 19.7885C3.8974 19.7885 3.74996 19.7308 3.63458 19.6154C3.51919 19.5 3.4615 19.3526 3.4615 19.1731C3.4615 19.0961 3.47432 19.032 3.49996 18.9808L5.42304 13.25L0.423039 9.82691C0.243552 9.69871 0.153809 9.53204 0.153809 9.32691C0.153809 9.14743 0.211501 8.99999 0.326886 8.88461C0.44227 8.76922 0.589706 8.71153 0.769193 8.71153H6.92304L8.80766 2.98076C8.88458 2.69871 9.07689 2.55768 9.38458 2.55768C9.69227 2.55768 9.88458 2.69871 9.9615 2.98076L11.8461 8.71153H18C18.1795 8.71153 18.3269 8.76922 18.4423 8.88461C18.5577 8.99999 18.6153 9.14743 18.6153 9.32691C18.6153 9.53204 18.5256 9.69871 18.3461 9.82691L13.3461 13.25L15.2692 18.9808C15.2948 19.032 15.3077 19.0961 15.3077 19.1731C15.3077 19.3526 15.25 19.5 15.1346 19.6154C15.0192 19.7308 14.8718 19.7885 14.6923 19.7885Z" fill="black" />
                                                        </svg>
                                                        <Text style={styles.rate}>{getRating(selectedObjectMap.requests.filter(request => request.rating > 0 && dayjs(request.ratingAt).diff(dayjs(), 'day') <= -3))}</Text>
                                                    </View> : ""}
                                            </View>
                                            {
                                                getMinDiscount(selectedObjectMap.schedules) && getMinPrice(selectedObjectMap.schedules) > getMinDiscount(selectedObjectMap.schedules) ? (
                                                    <View style={{ flexDirection: 'row' }}>
                                                        <Text style={styles.price}>от </Text>
                                                        <Text style={[styles.price, { textDecorationLine: 'line-through', color: '#667085', fontWeight: '400' }]}>{getMinPrice(selectedObjectMap.schedules)} ₽</Text>
                                                        <Text style={styles.price}> {getMinDiscount(selectedObjectMap.schedules)} ₽</Text>
                                                    </View>
                                                ) : (
                                                    <Text style={styles.price}>от {getMinPrice(selectedObjectMap.schedules)} ₽</Text>
                                                )
                                            }
                                        </View>
                                    </View>
                                </TouchableOpacity>
                            </View>
                        : null
                }
                <TouchableOpacity onPress={() => { ym(95094888, 'reachGoal', 'OPEN_OBJECTS_LIST'); setModeList(); }} style={styles.modeButton}>
                    <Ionicons style={styles.modeIcon} name='list-outline' size={22} color='#000000' />
                    <Text style={styles.modeText}>Список</Text>
                </TouchableOpacity>
                <Modal
                    visible={modalFilter}
                    // visible={true}
                    animationType={windowWidth > 768 ? 'fade' : 'slide'}
                    transparent={true}

                >
                    <ScrollView>
                        <View style={styles.modalComfortsWrapFirst}>
                            <TouchableOpacity onPress={() => setModalFilter(false)} style={styles.modalComfortsCloseBtn}></TouchableOpacity>
                            <View style={styles.modalComfortsWrap}>
                                <View style={styles.modalComfortsClose}>
                                    <Text style={styles.modalComfortsTitle}>Фильтры</Text>
                                </View>
                                <View style={styles.modalComfortsForm}>
                                    <Text style={styles.modalComfortsFormTitle}>Дата</Text>
                                    <View style={{ marginBottom: 20 }}>
                                        <TouchableOpacity onPress={handleShowFilterCalendar}>
                                            {
                                                formattedDate ? (
                                                    <Text style={[styles.filterCalendarText, { width: windowWidth > 768 ? showFilterCalendar ? '100%' : 272 : '100%', }]}>{formattedDate}</Text>
                                                ) : (
                                                    <Text style={[styles.filterCalendarText, { width: windowWidth > 768 ? showFilterCalendar ? '100%' : 272 : '100%', color: '#6B7280' }]}>Выбрать дату</Text>
                                                )
                                            }
                                        </TouchableOpacity>
                                        <Calendar
                                            firstDay={1}
                                            current={today}
                                            disableAllTouchEventsForDisabledDays={true}
                                            style={[styles.modalComfortsFormCalendar, { display: showFilterCalendar ? 'flex' : 'none' }]}
                                            renderArrow={(direction) => <Ionicons size={20} name={direction === 'left' ? 'ios-chevron-back' : 'ios-chevron-forward'} />}
                                            theme={{
                                                selectedDayBackgroundColor: 'rgb(188, 200, 178)',
                                                todayTextColor: '#000',
                                                width: '100%',
                                            }}
                                            markedDates={{
                                                [selectedDate]: { selected: true, marked: true, selectedColor: 'rgb(188, 200, 178)' },
                                                ...getDisabledDates(today),
                                            }}
                                            onDayPress={selectCalendar}
                                        />
                                    </View>
                                    <Text style={styles.modalComfortsFormTitle}>Цена</Text>
                                    <View style={styles.modalComfortsFormPriceInputWrap}>
                                        <TextInput
                                            style={[styles.modalComfortsFormPriceInput, { marginRight: 32 }]}
                                            placeholder='От'
                                            keyboardType='numeric'
                                            value={minPrice}
                                            onChangeText={handleMinPrice}
                                            placeholderTextColor="#6B7280"
                                        />
                                        <TextInput
                                            style={[styles.modalComfortsFormPriceInput, { marginRight: 8 }]}
                                            placeholder='До'
                                            keyboardType='numeric'
                                            value={maxPrice}
                                            onChangeText={handleMaxPrice}
                                            placeholderTextColor="#6B7280"
                                        />
                                        <Text>₽</Text>
                                    </View>
                                    <Text style={styles.modalComfortsFormTitle}>Количество гостей</Text>
                                    <TextInput
                                        style={styles.modalComfortsFormTextInput}
                                        placeholder='Введите количество гостей'
                                        keyboardType='numeric'
                                        value={peopleCount}
                                        onChangeText={handlePeopleCount}
                                        placeholderTextColor="#6B7280"
                                    />
                                    <Text style={styles.modalComfortsFormTitle}>Количество спальных мест</Text>
                                    <TextInput
                                        style={styles.modalComfortsFormTextInput}
                                        placeholder='Введите количество спальных мест'
                                        keyboardType='numeric'
                                        value={bedCount}
                                        onChangeText={handleBedCount}
                                        placeholderTextColor="#6B7280"
                                    />
                                    <Text style={styles.modalComfortsFormTitle}>Расположение</Text>
                                    <Select
                                        className='select'
                                        styles={{
                                            control: (baseStyles) => ({
                                                ...baseStyles,
                                                borderWidth: 1,
                                                minHeight: 43,
                                                borderColor: '#D1D5DB',
                                                borderRadius: 8,
                                                backgroundColor: '#F9FAFB',
                                                paddingHorizontal: 10,
                                                boxShadow: 'none',
                                                '&:hover': {
                                                    border: '1 !important'
                                                },
                                            }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isSelected ? '#BCC8B2' : 'transparent',
                                            }),
                                            menu: (baseStyles) => ({
                                                ...baseStyles,
                                                marginLeft: '0.5%'
                                            })
                                        }}
                                        placeholder='Выберите расположение'
                                        isMulti
                                        options={places}
                                        onChange={(selectedOption) => {
                                            // Вызов setPlace при выборе новой опции
                                            setSelectedPlace(selectedOption);
                                        }}
                                        value={selectedPlace}
                                    />
                                    <Text style={[styles.modalComfortsFormTitle, { marginTop: 20 }]}>Удобства</Text>
                                    <View style={[styles.modalComfortsFormFacilities, { maxHeight: isExpanded ? 'none' : 236 }]}>
                                        {comforts.map(comfort => (
                                            <TouchableOpacity onPress={() => choiceConvenience(comfort)} key={comfort.value} style={styles.modalCheckboxWrapper}>
                                                <View
                                                    style={styles.modalCheckboxWrapperCheckBox}
                                                >
                                                    {convenience.includes(comfort.value) && (
                                                        <Text style={{ marginLeft: 2 }}>✓</Text>
                                                    )}
                                                </View>
                                                <Text style={styles.modalCheckboxWrapperLabel}>{comfort.label}</Text>
                                            </TouchableOpacity>

                                        ))}
                                    </View>
                                    <TouchableOpacity
                                        onPress={handleToggle}
                                    >
                                        <Text style={styles.modalComfortsBtnShowAll}>
                                            {isExpanded ? 'Свернуть' : 'Показать все'}
                                        </Text>
                                    </TouchableOpacity>
                                </View>
                                <View style={styles.modalComfortsFormBtnsWrap}>
                                    <TouchableOpacity style={styles.modalComfortsFormReset} onPress={handleReset}>
                                        <Text>Очистить</Text>
                                    </TouchableOpacity>
                                    <TouchableOpacity style={styles.modalComfortsFormSubmit} onPress={handleSearch}>
                                        <Text>Показать {filterData(sortedAndFilteredObjects).length} домиков</Text>
                                    </TouchableOpacity>
                                </View>
                            </View>
                        </View>
                    </ScrollView>
                </Modal>
            </>
        )
    }

    return (
        <>
            <ScrollView
                style={styles.container}
                ref={ref}
                onScroll={handleScroll}
                scrollEventThrottle={60}
            >
                <View id="objects-wrap">
                    <div id='most50933'></div>
                </View>
                <Window style={{ backgroundColor: '#fff', paddingHorizontal: 16, marginTop: windowWidth > 768 ? 80 : 0, maxWidth: 1024, zIndex: 10 }}>
                    <View style={styles.objectsTopWrap}>
                        <View style={{ display: windowWidth > 767 ? 'contents' : 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                            <View style={styles.searchWrap}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="27" viewBox="0 0 24 27" fill="none">
                                    <path d="M21.3873 21.1126C21.5741 21.3617 21.6675 21.6264 21.6675 21.9066C21.6675 22.2179 21.5508 22.4904 21.3172 22.7239C21.0837 22.9574 20.8113 23.0742 20.4999 23.0742C20.2197 23.0742 19.9551 22.9808 19.706 22.794L15.3159 18.4038C15.0356 18.6218 14.6854 18.832 14.265 19.0343C13.8447 19.2367 13.4244 19.408 13.0041 19.5481C12.5837 19.6882 12.1478 19.7972 11.6964 19.875C11.2449 19.9528 10.8323 19.9918 10.4587 19.9918C8.18583 19.9918 6.25542 19.1978 4.66751 17.6099C3.0796 16.022 2.28564 14.0994 2.28564 11.842C2.28564 9.5847 3.0796 7.66208 4.66751 6.07417C6.25542 4.48626 8.17804 3.6923 10.4354 3.6923C12.6927 3.6923 14.6153 4.48626 16.2032 6.07417C17.7911 7.66208 18.5851 9.59249 18.5851 11.8654C18.5851 12.6126 18.4294 13.4611 18.1181 14.4107C17.8067 15.3603 17.4331 16.1309 16.9972 16.7225L21.3873 21.1126ZM6.32548 7.73214C6.32548 7.73214 6.04137 8.01625 5.47314 8.58447C4.90492 9.1527 4.62081 10.2386 4.62081 11.842C4.62081 13.4455 5.18903 14.8155 6.32548 15.9519C7.46193 17.0884 8.83189 17.6644 10.4354 17.6799C12.0388 17.6955 13.4166 17.1273 14.5686 15.9753C15.7206 14.8233 16.2966 13.4455 16.2966 11.842C16.2966 10.2386 15.7206 8.86859 14.5686 7.73214C13.4166 6.59569 12.0388 6.02747 10.4354 6.02747C8.83189 6.02747 7.46193 6.59569 6.32548 7.73214Z" fill="black" />
                                </svg>
                                <TextInput
                                    style={styles.searchInput}
                                    placeholder="Поиск по названию"
                                    value={searchQuery}
                                    onChangeText={(text) => setSearchQuery(text)}
                                    placeholderTextColor="#6B7280"
                                    onFocus={() => {
                                        setIsSearchListVisible(true);
                                    }}
                                    onBlur={() => {
                                        setTimeout(() => {
                                            setIsSearchListVisible(false);
                                        }, 200);
                                    }}
                                />
                                {
                                    searchQuery && (
                                        <TouchableOpacity onPress={() => setSearchQuery('')}>
                                            <Text style={styles.filterInputDelete}>+</Text>
                                        </TouchableOpacity>
                                    )
                                }
                            </View>
                            <TouchableOpacity
                                onPress={() => setModalFilter(true)}
                                style={styles.filterBtn}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                    <path d="M2.50008 6.33334H3.68675C3.85986 6.87731 4.20154 7.35212 4.66235 7.68906C5.12317 8.026 5.67922 8.2076 6.25008 8.2076C6.82094 8.2076 7.377 8.026 7.83781 7.68906C8.29863 7.35212 8.6403 6.87731 8.81342 6.33334H17.5001C17.7211 6.33334 17.9331 6.24554 18.0893 6.08926C18.2456 5.93298 18.3334 5.72102 18.3334 5.5C18.3334 5.27899 18.2456 5.06703 18.0893 4.91075C17.9331 4.75447 17.7211 4.66667 17.5001 4.66667H8.81342C8.6403 4.12269 8.29863 3.64789 7.83781 3.31095C7.377 2.97401 6.82094 2.7924 6.25008 2.7924C5.67922 2.7924 5.12317 2.97401 4.66235 3.31095C4.20154 3.64789 3.85986 4.12269 3.68675 4.66667H2.50008C2.27907 4.66667 2.06711 4.75447 1.91083 4.91075C1.75455 5.06703 1.66675 5.27899 1.66675 5.5C1.66675 5.72102 1.75455 5.93298 1.91083 6.08926C2.06711 6.24554 2.27907 6.33334 2.50008 6.33334Z" fill="#1F2A37" />
                                    <path d="M17.5001 9.66667H16.3134C16.1403 9.12269 15.7986 8.64789 15.3378 8.31095C14.877 7.97401 14.3209 7.7924 13.7501 7.7924C13.1792 7.7924 12.6232 7.97401 12.1624 8.31095C11.7015 8.64789 11.3599 9.12269 11.1867 9.66667H2.50008C2.27907 9.66667 2.06711 9.75447 1.91083 9.91075C1.75455 10.067 1.66675 10.279 1.66675 10.5C1.66675 10.721 1.75455 10.933 1.91083 11.0893C2.06711 11.2455 2.27907 11.3333 2.50008 11.3333H11.1867C11.3599 11.8773 11.7015 12.3521 12.1624 12.6891C12.6232 13.026 13.1792 13.2076 13.7501 13.2076C14.3209 13.2076 14.877 13.026 15.3378 12.6891C15.7986 12.3521 16.1403 11.8773 16.3134 11.3333H17.5001C17.7211 11.3333 17.9331 11.2455 18.0893 11.0893C18.2456 10.933 18.3334 10.721 18.3334 10.5C18.3334 10.279 18.2456 10.067 18.0893 9.91075C17.9331 9.75447 17.7211 9.66667 17.5001 9.66667Z" fill="#1F2A37" />
                                    <path d="M17.5001 14.6667H8.81342C8.6403 14.1227 8.29863 13.6479 7.83781 13.311C7.377 12.974 6.82094 12.7924 6.25008 12.7924C5.67922 12.7924 5.12317 12.974 4.66235 13.311C4.20154 13.6479 3.85986 14.1227 3.68675 14.6667H2.50008C2.27907 14.6667 2.06711 14.7545 1.91083 14.9107C1.75455 15.067 1.66675 15.279 1.66675 15.5C1.66675 15.721 1.75455 15.933 1.91083 16.0893C2.06711 16.2455 2.27907 16.3333 2.50008 16.3333H3.68675C3.85986 16.8773 4.20154 17.3521 4.66235 17.6891C5.12317 18.026 5.67922 18.2076 6.25008 18.2076C6.82094 18.2076 7.377 18.026 7.83781 17.6891C8.29863 17.3521 8.6403 16.8773 8.81342 16.3333H17.5001C17.7211 16.3333 17.9331 16.2455 18.0893 16.0893C18.2456 15.933 18.3334 15.721 18.3334 15.5C18.3334 15.279 18.2456 15.067 18.0893 14.9107C17.9331 14.7545 17.7211 14.6667 17.5001 14.6667Z" fill="#1F2A37" />
                                </svg>
                                <Text style={styles.filterBtnText}>
                                    Фильтры
                                </Text>
                            </TouchableOpacity>
                        </View>
                        {/* <TouchableOpacity
                            onPress={() => navigation.navigate('Filter', { type: 'objects', from, to, date, people, place, bed, heat, sort, comfort: JSON.stringify(comfort), company: JSON.stringify(company) })}
                            style={styles.sortBtn}
                        >
                            <Text style={{marginRight: 8}}>
                                Сортировка
                            </Text>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0102 13C9.78916 13 9.57724 12.9123 9.42099 12.7563L6.08766 9.42981C6.00807 9.3531 5.94458 9.26133 5.90091 9.15987C5.85723 9.05841 5.83424 8.94928 5.83328 8.83886C5.83232 8.72843 5.85341 8.61892 5.89531 8.51672C5.93721 8.41452 5.99909 8.32166 6.07733 8.24358C6.15557 8.1655 6.24862 8.10374 6.35103 8.06193C6.45344 8.02011 6.56318 7.99907 6.67383 8.00003C6.78448 8.00099 6.89383 8.02393 6.9955 8.06752C7.09717 8.1111 7.18912 8.17446 7.26599 8.25389L10.0102 10.9924L12.7543 8.25389C12.9115 8.1024 13.122 8.01858 13.3405 8.02047C13.559 8.02237 13.768 8.10983 13.9225 8.26402C14.077 8.41821 14.1647 8.62679 14.1666 8.84484C14.1685 9.06289 14.0845 9.27296 13.9327 9.42981L10.5993 12.7563C10.4431 12.9123 10.2312 13 10.0102 13Z" fill="#1F2A37"/>
                            </svg>
                        </TouchableOpacity> */}
                        <CreatableSelect
                            placeholder='Сортировка'
                            className='select'
                            styles={{
                                control: (baseStyles) => ({
                                    ...baseStyles,
                                    height: 46,
                                    boxShadow: 'none',
                                    '&:hover': {
                                        border: '1 !important'
                                    },
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    color: '#1F2A37',
                                    fontSize: 14,
                                    borderColor: '#D1D5DB',
                                    borderWidth: 1,
                                    borderRadius: 100,
                                    paddingHorizontal: 16,
                                    paddingVertical: 12,
                                    margin: 0,
                                    marginTop: windowWidth > 767 ? 0 : 16
                                }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isSelected ? '#BCC8B2' : 'transparent',
                                    fontSize: 14
                                }),
                                menu: (baseStyles) => ({
                                    ...baseStyles,
                                    width: 'max-content',
                                    minWidth: '99%',
                                    marginLeft: '0.5%',
                                })
                            }}
                            options={sortItems}
                            onChange={(option) => handleSortChange(option ? option.value : null)}
                            value={sortItems.find(option => option.value === sortBy)}
                        />
                    </View>
                    {
                        searchQuery.length > 0 && filterData(sortedAndFilteredObjects).length > 0 && isSearchListVisible && (
                            <View style={{ paddingHorizontal: 16 }}>
                                <View style={[styles.searchList, { top: 12 }]}>
                                    {
                                        filterData(sortedAndFilteredObjects).slice(0, 7).map((object, index) => (
                                            <TouchableOpacity
                                                style={styles.searchListItem}
                                                onPress={() => handleSelectSearchList(object)}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M17.2892 9.46966L15.7874 7.96965L10.5309 2.71959C10.3901 2.57899 10.1991 2.5 10 2.5C9.80088 2.5 9.60992 2.57899 9.4691 2.71959L4.21264 7.96965L2.71079 9.46966C2.57401 9.61112 2.49832 9.80057 2.50003 9.99722C2.50174 10.1939 2.58071 10.382 2.71994 10.521C2.85917 10.6601 3.04751 10.739 3.2444 10.7407C3.44129 10.7424 3.63097 10.6668 3.7726 10.5302L3.99262 10.3104V16C3.99262 16.3978 4.15085 16.7793 4.4325 17.0607C4.71415 17.342 5.09615 17.5 5.49446 17.5H8.49815C8.69731 17.5 8.88831 17.421 9.02914 17.2803C9.16996 17.1397 9.24908 16.9489 9.24908 16.75V13H10.7509V16.75C10.7509 16.9489 10.83 17.1397 10.9709 17.2803C11.1117 17.421 11.3027 17.5 11.5018 17.5H14.5055C14.9039 17.5 15.2858 17.342 15.5675 17.0607C15.8492 16.7793 16.0074 16.3978 16.0074 16V10.3104L16.2274 10.5302C16.369 10.6668 16.5587 10.7424 16.7556 10.7407C16.9525 10.739 17.1408 10.6601 17.2801 10.521C17.4193 10.382 17.4983 10.1939 17.5 9.99722C17.5017 9.80057 17.426 9.61112 17.2892 9.46966ZM14.5055 16H12.2528V13C12.2528 12.6021 12.0945 12.2206 11.8129 11.9393C11.5312 11.658 11.1492 11.4999 10.7509 11.4999H9.24908C8.85076 11.4999 8.46876 11.658 8.18711 11.9393C7.90546 12.2206 7.74723 12.6021 7.74723 13V16H5.49446V8.81041L10 4.31036L14.5055 8.81041V16Z" fill="#374151" />
                                                </svg>
                                                <Text>{object.name}</Text>
                                            </TouchableOpacity>
                                        ))
                                    }
                                </View>
                            </View>
                        )
                    }
                    {/* <TouchableOpacity onPress={() => navigation.navigate('Filter', { type: 'objects', from, to, date, people, place, bed, heat, sort, comfort: JSON.stringify(comfort), company: JSON.stringify(company) })} style={styles.searchContainer}>
                        <View>
                            <Text style={styles.searchText}>Фильтр навигация</Text>
                        </View>
                    </TouchableOpacity> */}
                    <View style={styles.filterSelectsWrap}>
                        {
                            selectedDate.length > 0 && (
                                <View style={styles.filterSelectItem}>
                                    <TouchableOpacity onPress={() => setModalFilter(true)}>
                                        <Text style={styles.filterSelectItemText}>{formattedDate}</Text>
                                    </TouchableOpacity>
                                    <TouchableOpacity onPress={handleCloseCalendarFilter}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512"><path fill="currentColor" d="m289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34Z" />
                                        </svg>
                                    </TouchableOpacity>
                                </View>
                            )
                        }
                        {(minPrice && maxPrice) || (minPrice.length > 0 || maxPrice.length > 0) ? (
                            <View style={styles.filterSelectItem}>
                                <TouchableOpacity onPress={() => setModalFilter(true)}>
                                    <Text style={styles.filterSelectItemText}>
                                        {
                                            minPrice.length > 0 && (
                                                'От ' + minPrice + ' ₽ '
                                            )
                                        }
                                        {
                                            maxPrice.length > 0 && (
                                                'до ' + maxPrice + ' ₽'
                                            )
                                        }
                                    </Text>
                                </TouchableOpacity>
                                <TouchableOpacity onPress={handleClosePriceFilter}>
                                    {/* Использование SVG для кнопки закрытия */}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512">
                                        <path fill="currentColor" d="m289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34Z" />
                                    </svg>
                                </TouchableOpacity>
                            </View>
                        ) : null}
                        {
                            peopleCount.length > 0 && (
                                <View style={styles.filterSelectItem}>
                                    <TouchableOpacity onPress={() => setModalFilter(true)}>
                                        <Text style={styles.filterSelectItemText}>{peopleCount} гостей</Text>
                                    </TouchableOpacity>
                                    <TouchableOpacity onPress={handleClosePeopleCountFilter}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512"><path fill="currentColor" d="m289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34Z" />
                                        </svg>
                                    </TouchableOpacity>
                                </View>
                            )
                        }
                        {
                            bedCount.length > 0 && (
                                <View style={styles.filterSelectItem}>
                                    <TouchableOpacity onPress={() => setModalFilter(true)}>
                                        <Text style={styles.filterSelectItemText}>{bedCount} сп. мест</Text>
                                    </TouchableOpacity>
                                    <TouchableOpacity onPress={handleCloseBedCountFilter}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512"><path fill="currentColor" d="m289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34Z" />
                                        </svg>
                                    </TouchableOpacity>
                                </View>
                            )
                        }
                        {
                            selectedTags.length > 0 && (
                                selectedTags.map(selectedTag => (
                                    <View key={selectedTag} style={styles.filterSelectItem}>
                                        {
                                            comforts.map(comfort => (
                                                comfort.value == selectedTag && (
                                                    <TouchableOpacity key={comfort.value} onPress={() => setModalFilter(true)}>
                                                        <Text style={styles.filterSelectItemText}>{comfort.label}</Text>
                                                    </TouchableOpacity>
                                                )
                                            ))
                                        }
                                        <TouchableOpacity onPress={() => handleCloseSelectedTagsFilter(selectedTag)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512"><path fill="currentColor" d="m289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34Z" />
                                            </svg>
                                        </TouchableOpacity>
                                    </View>
                                ))
                            )
                        }
                        {
                            selectedPlace.length > 0 && (
                                selectedPlace.map(place => (
                                    <View key={place} style={styles.filterSelectItem}>
                                        <TouchableOpacity onPress={() => setModalFilter(true)}>
                                            <Text>{place.label}</Text>
                                        </TouchableOpacity>
                                        <TouchableOpacity onPress={() => handleCloseSelectedPlaceFilter(place)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512"><path fill="currentColor" d="m289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34Z" />
                                            </svg>
                                        </TouchableOpacity>
                                    </View>
                                ))
                            )
                        }
                    </View>
                    {
                        searchQuery.length > 0 &&
                        <Text style={styles.searchQueryResult}>Результаты по запросу «{searchQuery}»</Text>
                    }
                </Window>
                {
                    modalFilter == true && (
                        <Animated.View style={[styles.modalFilterBackground, { opacity: opacityAnim }]} />
                    )
                }
                <Modal
                    visible={modalFilter}
                    // visible={true}
                    animationType={windowWidth > 768 ? 'fade' : 'slide'}
                    transparent={true}

                >
                    <ScrollView>
                        <View style={styles.modalComfortsWrapFirst}>
                            <TouchableOpacity onPress={() => setModalFilter(false)} style={styles.modalComfortsCloseBtn}></TouchableOpacity>
                            <View style={styles.modalComfortsWrap}>
                                <View style={styles.modalComfortsClose}>
                                    <Text style={styles.modalComfortsTitle}>Фильтры</Text>
                                </View>
                                <View style={styles.modalComfortsForm}>
                                    <Text style={styles.modalComfortsFormTitle}>Дата</Text>
                                    <View style={{ marginBottom: 20 }}>
                                        <TouchableOpacity onPress={handleShowFilterCalendar}>
                                            {
                                                formattedDate ? (
                                                    <Text style={[styles.filterCalendarText, { width: windowWidth > 768 ? showFilterCalendar ? '100%' : 272 : '100%', }]}>{formattedDate}</Text>
                                                ) : (
                                                    <Text style={[styles.filterCalendarText, { width: windowWidth > 768 ? showFilterCalendar ? '100%' : 272 : '100%', color: '#6B7280' }]}>Выбрать дату</Text>
                                                )
                                            }
                                        </TouchableOpacity>
                                        <Calendar
                                            firstDay={1}
                                            current={today}
                                            disableAllTouchEventsForDisabledDays={true}
                                            style={[styles.modalComfortsFormCalendar, { display: showFilterCalendar ? 'flex' : 'none' }]}
                                            renderArrow={(direction) => <Ionicons size={20} name={direction === 'left' ? 'ios-chevron-back' : 'ios-chevron-forward'} />}
                                            theme={{
                                                selectedDayBackgroundColor: 'rgb(188, 200, 178)',
                                                todayTextColor: '#000',
                                                width: '100%',
                                            }}
                                            markedDates={{
                                                [selectedDate]: { selected: true, marked: true, selectedColor: 'rgb(188, 200, 178)' },
                                                ...getDisabledDates(today),
                                            }}
                                            onDayPress={selectCalendar}
                                        />
                                    </View>
                                    <Text style={styles.modalComfortsFormTitle}>Цена</Text>
                                    <View style={styles.modalComfortsFormPriceInputWrap}>
                                        <TextInput
                                            style={[styles.modalComfortsFormPriceInput, { marginRight: 32 }]}
                                            placeholder='От'
                                            keyboardType='numeric'
                                            value={minPrice}
                                            onChangeText={handleMinPrice}
                                            placeholderTextColor="#6B7280"
                                        />
                                        <TextInput
                                            style={[styles.modalComfortsFormPriceInput, { marginRight: 8 }]}
                                            placeholder='До'
                                            keyboardType='numeric'
                                            value={maxPrice}
                                            onChangeText={handleMaxPrice}
                                            placeholderTextColor="#6B7280"
                                        />
                                        <Text>₽</Text>
                                    </View>
                                    <Text style={styles.modalComfortsFormTitle}>Количество гостей</Text>
                                    <TextInput
                                        style={styles.modalComfortsFormTextInput}
                                        placeholder='Введите количество гостей'
                                        keyboardType='numeric'
                                        value={peopleCount}
                                        onChangeText={handlePeopleCount}
                                        placeholderTextColor="#6B7280"
                                    />
                                    <Text style={styles.modalComfortsFormTitle}>Количество спальных мест</Text>
                                    <TextInput
                                        style={styles.modalComfortsFormTextInput}
                                        placeholder='Введите количество'
                                        keyboardType='numeric'
                                        value={bedCount}
                                        onChangeText={handleBedCount}
                                        placeholderTextColor="#6B7280"
                                    />
                                    <Text style={styles.modalComfortsFormTitle}>Расположение</Text>
                                    <Select
                                        className='select'
                                        styles={{
                                            control: (baseStyles) => ({
                                                ...baseStyles,
                                                borderWidth: 1,
                                                minHeight: 43,
                                                borderColor: '#D1D5DB',
                                                borderRadius: 8,
                                                backgroundColor: '#F9FAFB',
                                                paddingHorizontal: 10,
                                                boxShadow: 'none',
                                                '&:hover': {
                                                    border: '1 !important'
                                                },
                                            }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isSelected ? '#BCC8B2' : 'transparent',
                                            }),
                                            menu: (baseStyles) => ({
                                                ...baseStyles,
                                                marginLeft: '0.5%'
                                            })
                                        }}
                                        placeholder='Выберите расположение'
                                        isMulti
                                        options={places}
                                        onChange={(selectedOption) => {
                                            // Вызов setPlace при выборе новой опции
                                            setSelectedPlace(selectedOption);
                                        }}
                                        value={selectedPlace}
                                    />
                                    <Text style={[styles.modalComfortsFormTitle, { marginTop: 20 }]}>Удобства</Text>
                                    <View style={[styles.modalComfortsFormFacilities, { maxHeight: isExpanded ? 'none' : 236 }]}>
                                        {comforts.map(comfort => (
                                            <TouchableOpacity onPress={() => choiceConvenience(comfort)} key={comfort.value} style={styles.modalCheckboxWrapper}>
                                                <View
                                                    style={styles.modalCheckboxWrapperCheckBox}
                                                >
                                                    {convenience.includes(comfort.value) && (
                                                        <Text style={{ marginLeft: 2 }}>✓</Text>
                                                    )}
                                                </View>
                                                <Text style={styles.modalCheckboxWrapperLabel}>{comfort.label}</Text>
                                            </TouchableOpacity>

                                        ))}
                                    </View>
                                    <TouchableOpacity
                                        onPress={handleToggle}
                                    >
                                        <Text style={styles.modalComfortsBtnShowAll}>
                                            {isExpanded ? 'Свернуть' : 'Показать все'}
                                        </Text>
                                    </TouchableOpacity>
                                </View>
                                <View style={styles.modalComfortsFormBtnsWrap}>
                                    <TouchableOpacity style={styles.modalComfortsFormReset} onPress={handleReset}>
                                        <Text>Очистить</Text>
                                    </TouchableOpacity>
                                    <TouchableOpacity style={styles.modalComfortsFormSubmit} onPress={handleSearch}>
                                        <Text>Показать {filterData(sortedAndFilteredObjects).length} домиков</Text>
                                    </TouchableOpacity>
                                </View>
                            </View>
                        </View>
                    </ScrollView>
                </Modal>
                <Window>
                    <View
                        style={styles.objectsContainer}
                    >
                        {
                            filterData(sortedAndFilteredObjects).length === 0 ? (
                                <Text style={styles.searchQueryResult}>По вашему запросу ничего не найдено</Text>
                            ) : (
                                filterData(sortedAndFilteredObjects).map((object, index) => (
                                    <TouchableOpacity key={index} onPress={() => openObject(object.id, selectedDate ? dayjs(selectedDate).format('DD.MM.YYYY') : '')}>
                                        <ImageBackground style={[styles.objectImage, { height: squareSize, width: squareSize }]} source={object.images_720.length > 0 ? { uri: imageUrl(object.images_720[0]) } : { uri: imageUrl(object.images[0]) }}>
                                            {
                                                user ? (
                                                    <>
                                                        {
                                                            object.favorite ? (
                                                                <TouchableOpacity onPress={() => removeToFavorite(object.id)} style={styles.favorite}>
                                                                    <Ionicons name='ios-heart-sharp' size={24} color='#475467' />
                                                                </TouchableOpacity>
                                                            ) : (
                                                                <TouchableOpacity onPress={() => addToFavorite(object.id)} style={styles.favorite}>
                                                                    <Ionicons name='ios-heart-outline' size={24} color='#475467' />
                                                                </TouchableOpacity>
                                                            )
                                                        }
                                                    </>
                                                ) : <View />
                                            }
                                            <View style={styles.tagsContainer}>
                                                {
                                                    getTags(object)
                                                }
                                            </View>
                                        </ImageBackground>
                                        <View style={[styles.infoContainer, { justifyContent: 'space-between', marginTop: 8, alignItems: 'center' }]}>
                                            <Text style={[styles.infoTitle, { maxWidth: squareSize - 200 }]}>{object.name}</Text>
                                            <View style={[styles.infoGroup, { maxWidth: 250 }]}>
                                                {
                                                    getPeople(object)
                                                }
                                                {
                                                    getSquare(object.square)
                                                }
                                                {getRating(object.requests.filter(object => object.rating > 0 && dayjs(object.ratingAt).diff(dayjs(), 'day') <= -3)) > 0 ?
                                                    <View style={[styles.infoContainer, { justifyContent: 'space-between', alignItems: 'center' }]}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
                                                            <path d="M14.6923 19.7885C14.5641 19.7885 14.4487 19.75 14.3461 19.6731L9.38458 16.0961L4.42304 19.6731C4.32048 19.75 4.20509 19.7885 4.07689 19.7885C3.8974 19.7885 3.74996 19.7308 3.63458 19.6154C3.51919 19.5 3.4615 19.3526 3.4615 19.1731C3.4615 19.0961 3.47432 19.032 3.49996 18.9808L5.42304 13.25L0.423039 9.82691C0.243552 9.69871 0.153809 9.53204 0.153809 9.32691C0.153809 9.14743 0.211501 8.99999 0.326886 8.88461C0.44227 8.76922 0.589706 8.71153 0.769193 8.71153H6.92304L8.80766 2.98076C8.88458 2.69871 9.07689 2.55768 9.38458 2.55768C9.69227 2.55768 9.88458 2.69871 9.9615 2.98076L11.8461 8.71153H18C18.1795 8.71153 18.3269 8.76922 18.4423 8.88461C18.5577 8.99999 18.6153 9.14743 18.6153 9.32691C18.6153 9.53204 18.5256 9.69871 18.3461 9.82691L13.3461 13.25L15.2692 18.9808C15.2948 19.032 15.3077 19.0961 15.3077 19.1731C15.3077 19.3526 15.25 19.5 15.1346 19.6154C15.0192 19.7308 14.8718 19.7885 14.6923 19.7885Z" fill="black" />
                                                        </svg>
                                                        <Text style={styles.rate}>{getRating(object.requests.filter(object => object.rating > 0 && dayjs(object.ratingAt).diff(dayjs(), 'day') <= -3))}</Text>
                                                    </View> : ""}
                                            </View>
                                        </View>
                                        {
                                            getMinDiscount(object.schedules) && getMinPrice(object.schedules) > getMinDiscount(object.schedules) ? (
                                                <View style={{ flexDirection: 'row' }}>
                                                    <Text style={styles.price}>от </Text>
                                                    <Text style={[styles.price, { textDecorationLine: 'line-through', color: '#667085', fontWeight: '400' }]}>{getMinPrice(object.schedules)} ₽</Text>
                                                    <Text style={styles.price}> {getMinDiscount(object.schedules)} ₽</Text>
                                                </View>
                                            ) : (
                                                <Text style={styles.price}>от {getMinPrice(object.schedules)} ₽</Text>
                                            )
                                        }
                                    </TouchableOpacity>
                                ))
                            )}
                    </View>
                    <Footer />
                </Window>
            </ScrollView>
            <TouchableOpacity onPress={() => { ym(95094888, 'reachGoal', 'OPEN_OBJECTS_MAP'); setMode('map'); }} style={styles.modeButton}>
                <Ionicons style={styles.modeIcon} size={22} name='map-outline' color='#000000' />
                <Text style={styles.modeText}>Карта</Text>
            </TouchableOpacity>
        </>
    )
}

const windowWidth = Dimensions.get('window').width;

const styles = StyleSheet.create({
    container: {
        flex: 1
    },
    searchContainer: {
        flexDirection: 'row',
        height: 56,
        borderRadius: 28,
        borderWidth: 1,
        borderColor: '#D0D5DD',
        alignItems: 'center',
        marginTop: 12,
        marginHorizontal: 16,
        marginBottom: 12,
        backgroundColor: '#fff'
    },
    searchIcon: {
        marginHorizontal: 12
    },
    searchTitle: {
        color: '#101828',
        fontSize: 12,
        fontWeight: '500',
        marginBottom: 2
    },
    searchText: {
        color: '#98A2B3',
        fontSize: 12,
        fontWeight: '400'
    },
    objectsContainer: {
        gap: 24,
        marginHorizontal: 16,
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginBottom: 24,
        minHeight: '100%'
    },
    objectImage: {
        borderRadius: 20,
        overflow: 'hidden',
        justifyContent: 'space-between'
    },
    infoContainer: {
        flexDirection: 'row',
        alignItems: 'flex-start'
    },
    infoGroup: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    infoTitle: {
        fontSize: 20,
        fontWeight: '500',
        color: '#101828',
    },
    infoPeopleCount: {
        fontSize: 16,
        fontWeight: '400',
        color: '#101828',
        marginLeft: 2,
    },
    rate: {
        fontSize: 16,
        color: '#101828',
        marginLeft: 4
    },
    price: {
        color: '#101828',
        fontSize: 16,
        fontWeight: '500',
    },
    favorite: {
        height: 40,
        width: 40,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 20,
        backgroundColor: '#F2F4F7',
        alignSelf: 'flex-end',
        margin: 16
    },
    favoriteMap: {
        height: 30,
        width: 30,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 16,
        backgroundColor: '#F2F4F7',
        alignSelf: 'flex-end',
        margin: 12
    },
    tagsContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: 16
    },
    tagHot: {
        height: 28,
        width: 135,
        borderRadius: 6,
        backgroundColor: '#E6B762',
        justifyContent: 'center',
        alignItems: 'center'
    },
    hotText: {
        color: '#FCFCFD',
        fontSize: 16,
        fontWeight: 'bold'
    },
    tagDeadline: {
        height: 28,
        width: 135,
        borderRadius: 6,
        backgroundColor: '#EAECF0',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    deadlineText: {
        color: '#000',
        fontSize: 14,
        fontWeight: '400',
        marginLeft: 4
    },
    modeButton: {
        backgroundColor: '#e6b762',
        height: 70,
        width: 190,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 18,
        position: 'absolute',
        bottom: 12,
        alignSelf: 'center',
        flexDirection: 'row'
    },
    modeText: {
        color: '#000000',
        fontSize: 22,
        marginLeft: 4,
    },
    modeIcon: {
        marginTop: 2
    },
    searchWrap: {
        flexDirection: 'row',
        borderColor: '#D1D5DB',
        backgroundColor: '#fff',
        borderWidth: 1,
        borderRadius: 100,
        maxWidth: 436,
        width: '100%',
        paddingHorizontal: 12,
        paddingVertical: 9,
        alignItems: 'center',
        marginRight: windowWidth > 767 ? 24 : 16,
        flex: 1
    },
    searchInput: {
        marginLeft: 20,
        fontSize: 14,
        lineHeight: '150%',
        fontFamily: 'Inter',
        width: '100%',
    },
    objectsTopWrap: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 32,
        flexWrap: 'wrap'
    },
    filterBtn: {
        flexDirection: 'row',
        alignItems: 'center',
        color: '#1F2A37',
        fontSize: 14,
        borderColor: '#D1D5DB',
        borderWidth: 1,
        borderRadius: 100,
        paddingHorizontal: 16,
        paddingVertical: 12,
        marginRight: windowWidth > 768 ? 12 : 0,
        backgroundColor: '#fff'
    },
    filterBtnText: {
        marginLeft: 8,
        display: windowWidth > 768 ? 'flex' : 'none'
    },
    filterBtnTextTwo: {
        marginLeft: 8,
    },
    modalComfortsWrapFirst: {
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10,
        position: 'relative',
        backgroundColor: windowWidth > 768 ? 'rgba(0, 0, 0, 0.5)' : 'none',
    },
    modalFilterBackground: {
        backgroundColor: windowWidth > 768 ? 'none' : 'rgba(0, 0, 0, 0.5)',
        position: 'absolute',
        height: '100%',
        width: '100%',
        zIndex: 10
    },
    modalComfortsWrap: {
        borderRadius: windowWidth > 768 ? 16 : 0,
        borderTopStartRadius: windowWidth > 768 ? 16 : 16,
        borderTopEndRadius: 16,
        maxWidth: 800,
        width: '100%',
        backgroundColor: '#fff',
        overflow: 'hidden',
        marginVertical: windowWidth > 768 ? 80 : 0,
        zIndex: 100,
        position: 'relative',
        minHeight: windowWidth > 768 ? '90vh' : '100vh',
        marginTop: windowWidth > 768 ? 80 : 101
    },
    modalObjectInfoBackground: {
        flex: 1,
        justifyContent: 'flex-end',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    modalObjectInfoContainer: {
        backgroundColor: '#fff',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        padding: 10,
    },
    modalObjectInfoContent: {
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        paddingTop: 5,
        paddingBottom: 5
    },
    modalComfortsClose: {
        backgroundColor: '#fff',
        paddingTop: windowWidth > 768 ? 24 : 22,
        paddingBottom: windowWidth > 768 ? 16 : 22,
        paddingHorizontal: windowWidth > 768 ? 24 : 22,
        borderBottomWidth: windowWidth > 768 ? 1 : 0,
        borderColor: '#E6E6E6',
    },
    modalComfortsTitle: {
        fontSize: 18,
        fontWeight: 600,
        lineHeight: '150%',
        color: '#111928'
    },
    modalComfortsCloseBtn: {
        width: '100%',
        height: '100%',
        position: 'absolute',
    },
    modalComfortsForm: {
        paddingHorizontal: 24,
        paddingTop: 24,
        paddingBottom: 42
    },
    modalComfortsFormCalendar: {
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderColor: '#D1D5DB',
        borderWidth: 1,
        borderRadius: 8,
        marginTop: 16,
    },
    filterCalendarText: {
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderColor: '#D1D5DB',
        borderWidth: 1,
        borderRadius: 8,
        backgroundColor: '#F9FAFB',
    },
    modalComfortsFormFacilities: {
        flexDirection: 'row',
        rowGap: 16,
        flexWrap: 'wrap',
        overflow: 'hidden'
    },
    modalComfortsBtnShowAll: {
        marginTop: 16,
        fontSize: 16,
        color: '#111928',
        lineHeight: '150%',
        textDecorationStyle: 'solid',
        textDecorationColor: '#111928',
        textDecorationLine: 'underline'
    },
    modalCheckboxWrapper: {
        flexDirection: 'row',
        alignItems: 'center',
        columnGap: 8,
        width: windowWidth > 768 ? '50%' : '100%',
    },
    modalCheckboxWrapperCheckBox: {
        borderColor: '#6B7280',
        borderRadius: 4,
        borderWidth: 1,
        borderStyle: 'solid',
        //outline: 0,
        width: 20,
        height: 20
    },
    searchQueryResult: {
        fontSize: 16,
        lineHeight: '150%',
        fontWeight: 500,
        marginBottom: 26,
        zIndex: '-1'
    },
    modalCheckboxWrapperLabel: {
        fontSize: 16,
        color: '#111928',
        lineHeight: 14
    },
    modalComfortsFormTitle: {
        fontSize: 18,
        fontWeight: 500,
        lineHeight: '150%',
        marginBottom: 16
    },
    modalComfortsFormTextInput: {
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderColor: '#D1D5DB',
        borderWidth: 1,
        borderRadius: 8,
        backgroundColor: '#F9FAFB',
        fontSize: 14,
        lineHeight: '125%',
        width: windowWidth > 768 ? 272 : '100%',
        marginBottom: 20
    },
    modalComfortsFormPriceInputWrap: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 20
    },
    modalComfortsFormPriceInput: {
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderColor: '#D1D5DB',
        borderWidth: 1,
        borderRadius: 8,
        backgroundColor: '#F9FAFB',
        fontSize: 14,
        lineHeight: '125%',
        width: windowWidth > 768 ? 120 : '100%'
    },
    modalComfortsFormBtnsWrap: {
        padding: 24,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTopColor: '#E5E7EB',
        borderTopWidth: 1
    },
    modalComfortsFormReset: {
        color: '#1F2A37',
        fontSize: 14
    },
    modalComfortsFormSubmit: {
        color: '#000',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '150%',
        backgroundColor: '#E6B762',
        borderRadius: 12,
        paddingHorizontal: 20,
        paddingVertical: 10
    },
    filterSelectsWrap: {
        flexDirection: 'row',
        gap: 8,
        marginTop: 16,
        marginBottom: windowWidth > 768 ? 34 : 16,
        flexWrap: 'wrap',
        zIndex: -1
    },
    filterSelectItem: {
        flexDirection: 'row',
        gap: 8,
        paddingHorizontal: 18,
        paddingVertical: 14,
        borderColor: '#D1D5DB',
        borderWidth: 1,
        borderRadius: 30,
        backgroundColor: '#fff'
    },
    filterSelectItemText: {
        fontSize: 14
    },
    loadMoreWrap: {
        alignItems: 'center',
        width: '100%'
    },
    loadMoreWrapText: {
        paddingHorizontal: 24,
        paddingVertical: 12,
        backgroundColor: '#E6B762',
        color: '#111928',
        borderRadius: 8
    },
    mapFilterHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        marginHorizontal: 8,
        marginTop: 32
    },
    filterInputDelete: {
        transform: [{ rotate: '45deg' }],
        position: 'absolute',
        right: '12px',
        fontSize: '16',
        fontWeight: 600,
        color: '#a3a3a3',
        bottom: '-8px'
    },
    searchList: {
        position: 'absolute',
        top: windowWidth > 768 ? 72 : 140,
        backgroundColor: '#fff',
        maxWidth: 436,
        width: '100%',
        left: 0,
        paddingHorizontal: 20,
        paddingVertical: 24,
        borderRadius: 16,
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 1,
        },
        shadowOpacity: 0.5,
        shadowRadius: 2.22,

        elevation: 10,
    },
    searchListItem: {
        marginVertical: 8,
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8
    },
})

export default ObjectsScreen
